/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnauthedRouteImport } from './routes/_unauthed'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TransparencyOrgIdRouteImport } from './routes/transparency/$orgId'
import { Route as JoinIdRouteImport } from './routes/join.$id'
import { Route as UnauthedVerifyEmailRouteImport } from './routes/_unauthed/verify-email'
import { Route as UnauthedSignUpRouteImport } from './routes/_unauthed/sign-up'
import { Route as UnauthedResetPasswordRouteImport } from './routes/_unauthed/reset-password'
import { Route as UnauthedLoginRouteImport } from './routes/_unauthed/login'
import { Route as UnauthedForgotPasswordRouteImport } from './routes/_unauthed/forgot-password'
import { Route as UnauthedEmailVerifiedRouteImport } from './routes/_unauthed/email-verified'
import { Route as AuthedCreateOrganizationRouteImport } from './routes/_authed/create-organization'
import { Route as AuthedOrgRouteImport } from './routes/_authed/_org'
import { Route as AuthedOnboardRouteImport } from './routes/_authed/_onboard'
import { Route as UnauthedLoginIndexRouteImport } from './routes/_unauthed/login.index'
import { Route as UnauthedLogin2faRouteImport } from './routes/_unauthed/login.2fa'
import { Route as AuthedOrgTransactionsRouteImport } from './routes/_authed/_org/transactions'
import { Route as AuthedOrgTestRouteImport } from './routes/_authed/_org/test'
import { Route as AuthedOrgTaxSetupRouteImport } from './routes/_authed/_org/tax-setup'
import { Route as AuthedOrgTaxRouteImport } from './routes/_authed/_org/tax'
import { Route as AuthedOrgSettingsRouteImport } from './routes/_authed/_org/settings'
import { Route as AuthedOrgRequestsRouteImport } from './routes/_authed/_org/requests'
import { Route as AuthedOrgReferralsRouteImport } from './routes/_authed/_org/referrals'
import { Route as AuthedOrgPoliciesRouteImport } from './routes/_authed/_org/policies'
import { Route as AuthedOrgOrganizationRouteImport } from './routes/_authed/_org/organization'
import { Route as AuthedOrgInsightsRouteImport } from './routes/_authed/_org/insights'
import { Route as AuthedOrgDashboardRouteImport } from './routes/_authed/_org/dashboard'
import { Route as AuthedOrgCardsRouteImport } from './routes/_authed/_org/cards'
import { Route as AuthedOrgBudgetsRouteImport } from './routes/_authed/_org/budgets'
import { Route as AuthedOrgBillPayRouteImport } from './routes/_authed/_org/bill-pay'
import { Route as AuthedOrgAccountingRouteImport } from './routes/_authed/_org/accounting'
import { Route as AuthedOrgSettingsIndexRouteImport } from './routes/_authed/_org/settings/index'
import { Route as AuthedOrgOrganizationIndexRouteImport } from './routes/_authed/_org/organization/index'
import { Route as AuthedOrgAccountingSetupIndexRouteImport } from './routes/_authed/_org/accounting-setup/index'
import { Route as AuthedOnboardOnboardIndexRouteImport } from './routes/_authed/_onboard/onboard.index'
import { Route as AuthedOrgTransactionsReimbursementsRouteImport } from './routes/_authed/_org/transactions/reimbursements'
import { Route as AuthedOrgTransactionsCardRouteImport } from './routes/_authed/_org/transactions/card'
import { Route as AuthedOrgTransactionsIdRouteImport } from './routes/_authed/_org/transactions/$id'
import { Route as AuthedOrgTaxRefundsRouteImport } from './routes/_authed/_org/tax/refunds'
import { Route as AuthedOrgSettingsProfileRouteImport } from './routes/_authed/_org/settings/profile'
import { Route as AuthedOrgSettingsNotificationsRouteImport } from './routes/_authed/_org/settings/notifications'
import { Route as AuthedOrgSettingsDevelopmentRouteImport } from './routes/_authed/_org/settings/development'
import { Route as AuthedOrgSettingsBankRouteImport } from './routes/_authed/_org/settings/bank'
import { Route as AuthedOrgRequestsIdRouteImport } from './routes/_authed/_org/requests/$id'
import { Route as AuthedOrgReferralsSendRouteImport } from './routes/_authed/_org/referrals.send'
import { Route as AuthedOrgReferralsHowItWorksRouteImport } from './routes/_authed/_org/referrals.how-it-works'
import { Route as AuthedOrgPoliciesExpenseRouteImport } from './routes/_authed/_org/policies/expense'
import { Route as AuthedOrgPoliciesApprovalRouteImport } from './routes/_authed/_org/policies/approval'
import { Route as AuthedOrgOrganizationStatementsRouteImport } from './routes/_authed/_org/organization/statements'
import { Route as AuthedOrgOrganizationPeopleRouteImport } from './routes/_authed/_org/organization/people'
import { Route as AuthedOrgCardsCreateRouteImport } from './routes/_authed/_org/cards/create'
import { Route as AuthedOrgCardsIdRouteImport } from './routes/_authed/_org/cards/$id'
import { Route as AuthedOrgBudgetsCreateRouteImport } from './routes/_authed/_org/budgets/create'
import { Route as AuthedOrgBudgetsGroupIdRouteImport } from './routes/_authed/_org/budgets/$groupId'
import { Route as AuthedOrgAccountingSyncHistoryRouteImport } from './routes/_authed/_org/accounting/sync-history'
import { Route as AuthedOrgAccountingSettingsRouteImport } from './routes/_authed/_org/accounting/settings'
import { Route as AuthedOnboardOnboardApprovedRouteImport } from './routes/_authed/_onboard/onboard.approved'
import { Route as AuthedOrgTaxIdIndexRouteImport } from './routes/_authed/_org/tax/$id.index'
import { Route as AuthedOrgSettingsChangePhoneIndexRouteImport } from './routes/_authed/_org/settings/change-phone.index'
import { Route as AuthedOrgSettingsChangeEmailIndexRouteImport } from './routes/_authed/_org/settings/change-email.index'
import { Route as AuthedOrgRequestsIdIndexRouteImport } from './routes/_authed/_org/requests/$id.index'
import { Route as AuthedOrgOrganizationSettingsIndexRouteImport } from './routes/_authed/_org/organization/settings.index'
import { Route as AuthedOrgCardsIdIndexRouteImport } from './routes/_authed/_org/cards/$id.index'
import { Route as AuthedOrgBudgetsGroupIdIndexRouteImport } from './routes/_authed/_org/budgets/$groupId.index'
import { Route as AuthedOrgAccountingIdIndexRouteImport } from './routes/_authed/_org/accounting/$id.index'
import { Route as AuthedOrgTransactionsReimbursementsSettingsRouteImport } from './routes/_authed/_org/transactions/reimbursements/settings'
import { Route as AuthedOrgTransactionsReimbursementsCreateRouteImport } from './routes/_authed/_org/transactions/reimbursements/create'
import { Route as AuthedOrgTransactionsReimbursementsIdRouteImport } from './routes/_authed/_org/transactions/reimbursements/$id'
import { Route as AuthedOrgTransactionsCardIdRouteImport } from './routes/_authed/_org/transactions/card.$id'
import { Route as AuthedOrgSettingsChangePhoneConfirmRouteImport } from './routes/_authed/_org/settings/change-phone.confirm'
import { Route as AuthedOrgSettingsChangeEmailConfirmRouteImport } from './routes/_authed/_org/settings/change-email.confirm'
import { Route as AuthedOrgRequestsCreateLimitIncreaseRouteImport } from './routes/_authed/_org/requests/create/limit-increase'
import { Route as AuthedOrgRequestsCreateCardRouteImport } from './routes/_authed/_org/requests/create/card'
import { Route as AuthedOrgRequestsIdEditRouteImport } from './routes/_authed/_org/requests/$id.edit'
import { Route as AuthedOrgPoliciesExpenseCreateRouteImport } from './routes/_authed/_org/policies/expense/create'
import { Route as AuthedOrgPoliciesApprovalCreateRouteImport } from './routes/_authed/_org/policies/approval/create'
import { Route as AuthedOrgOrganizationPeopleInvitationsRouteImport } from './routes/_authed/_org/organization/people/invitations'
import { Route as AuthedOrgOrganizationPeopleAllRouteImport } from './routes/_authed/_org/organization/people/all'
import { Route as AuthedOrgCardsIdTransactionsRouteImport } from './routes/_authed/_org/cards/$id.transactions'
import { Route as AuthedOrgCardsIdEditRouteImport } from './routes/_authed/_org/cards/$id.edit'
import { Route as AuthedOrgCardsIdActivityRouteImport } from './routes/_authed/_org/cards/$id.activity'
import { Route as AuthedOrgBudgetsGroupIdReportingRouteImport } from './routes/_authed/_org/budgets/$groupId.reporting'
import { Route as AuthedOrgBudgetsGroupIdEditRouteImport } from './routes/_authed/_org/budgets/$groupId.edit'
import { Route as AuthedOrgAccountingSyncHistoryIdRouteImport } from './routes/_authed/_org/accounting/sync-history.$id'
import { Route as AuthedOrgAccountingSettingsRulesRouteImport } from './routes/_authed/_org/accounting/settings.rules'
import { Route as AuthedOrgAccountingSettingsFieldsRouteImport } from './routes/_authed/_org/accounting/settings.fields'
import { Route as AuthedOrgPoliciesExpenseIdEditRouteImport } from './routes/_authed/_org/policies/expense/$id.edit'
import { Route as AuthedOrgPoliciesApprovalIdEditRouteImport } from './routes/_authed/_org/policies/approval/$id.edit'
import { Route as AuthedOrgAccountingSettingsFieldsIdRouteImport } from './routes/_authed/_org/accounting/settings.fields.$id'
import { Route as AuthedOrgOrganizationPeopleAllIdIndexRouteImport } from './routes/_authed/_org/organization/people/all.$id.index'
import { Route as AuthedOrgOrganizationPeopleAllIdEditRoleRouteImport } from './routes/_authed/_org/organization/people/all.$id.edit-role'

const UnauthedRoute = UnauthedRouteImport.update({
  id: '/_unauthed',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TransparencyOrgIdRoute = TransparencyOrgIdRouteImport.update({
  id: '/transparency/$orgId',
  path: '/transparency/$orgId',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinIdRoute = JoinIdRouteImport.update({
  id: '/join/$id',
  path: '/join/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthedVerifyEmailRoute = UnauthedVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => UnauthedRoute,
} as any)
const UnauthedSignUpRoute = UnauthedSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => UnauthedRoute,
} as any)
const UnauthedResetPasswordRoute = UnauthedResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => UnauthedRoute,
} as any)
const UnauthedLoginRoute = UnauthedLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => UnauthedRoute,
} as any)
const UnauthedForgotPasswordRoute = UnauthedForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => UnauthedRoute,
} as any)
const UnauthedEmailVerifiedRoute = UnauthedEmailVerifiedRouteImport.update({
  id: '/email-verified',
  path: '/email-verified',
  getParentRoute: () => UnauthedRoute,
} as any)
const AuthedCreateOrganizationRoute =
  AuthedCreateOrganizationRouteImport.update({
    id: '/create-organization',
    path: '/create-organization',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedOrgRoute = AuthedOrgRouteImport.update({
  id: '/_org',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedOnboardRoute = AuthedOnboardRouteImport.update({
  id: '/_onboard',
  getParentRoute: () => AuthedRoute,
} as any)
const UnauthedLoginIndexRoute = UnauthedLoginIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => UnauthedLoginRoute,
} as any)
const UnauthedLogin2faRoute = UnauthedLogin2faRouteImport.update({
  id: '/2fa',
  path: '/2fa',
  getParentRoute: () => UnauthedLoginRoute,
} as any)
const AuthedOrgTransactionsRoute = AuthedOrgTransactionsRouteImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => AuthedOrgRoute,
} as any)
const AuthedOrgTestRoute = AuthedOrgTestRouteImport.update({
  id: '/test',
  path: '/test',
  getParentRoute: () => AuthedOrgRoute,
} as any)
const AuthedOrgTaxSetupRoute = AuthedOrgTaxSetupRouteImport.update({
  id: '/tax-setup',
  path: '/tax-setup',
  getParentRoute: () => AuthedOrgRoute,
} as any)
const AuthedOrgTaxRoute = AuthedOrgTaxRouteImport.update({
  id: '/tax',
  path: '/tax',
  getParentRoute: () => AuthedOrgRoute,
} as any)
const AuthedOrgSettingsRoute = AuthedOrgSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedOrgRoute,
} as any)
const AuthedOrgRequestsRoute = AuthedOrgRequestsRouteImport.update({
  id: '/requests',
  path: '/requests',
  getParentRoute: () => AuthedOrgRoute,
} as any)
const AuthedOrgReferralsRoute = AuthedOrgReferralsRouteImport.update({
  id: '/referrals',
  path: '/referrals',
  getParentRoute: () => AuthedOrgRoute,
} as any)
const AuthedOrgPoliciesRoute = AuthedOrgPoliciesRouteImport.update({
  id: '/policies',
  path: '/policies',
  getParentRoute: () => AuthedOrgRoute,
} as any)
const AuthedOrgOrganizationRoute = AuthedOrgOrganizationRouteImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => AuthedOrgRoute,
} as any)
const AuthedOrgInsightsRoute = AuthedOrgInsightsRouteImport.update({
  id: '/insights',
  path: '/insights',
  getParentRoute: () => AuthedOrgRoute,
} as any)
const AuthedOrgDashboardRoute = AuthedOrgDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthedOrgRoute,
} as any)
const AuthedOrgCardsRoute = AuthedOrgCardsRouteImport.update({
  id: '/cards',
  path: '/cards',
  getParentRoute: () => AuthedOrgRoute,
} as any)
const AuthedOrgBudgetsRoute = AuthedOrgBudgetsRouteImport.update({
  id: '/budgets',
  path: '/budgets',
  getParentRoute: () => AuthedOrgRoute,
} as any)
const AuthedOrgBillPayRoute = AuthedOrgBillPayRouteImport.update({
  id: '/bill-pay',
  path: '/bill-pay',
  getParentRoute: () => AuthedOrgRoute,
} as any)
const AuthedOrgAccountingRoute = AuthedOrgAccountingRouteImport.update({
  id: '/accounting',
  path: '/accounting',
  getParentRoute: () => AuthedOrgRoute,
} as any)
const AuthedOrgSettingsIndexRoute = AuthedOrgSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedOrgSettingsRoute,
} as any)
const AuthedOrgOrganizationIndexRoute =
  AuthedOrgOrganizationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedOrgOrganizationRoute,
  } as any)
const AuthedOrgAccountingSetupIndexRoute =
  AuthedOrgAccountingSetupIndexRouteImport.update({
    id: '/accounting-setup/',
    path: '/accounting-setup/',
    getParentRoute: () => AuthedOrgRoute,
  } as any)
const AuthedOnboardOnboardIndexRoute =
  AuthedOnboardOnboardIndexRouteImport.update({
    id: '/onboard/',
    path: '/onboard/',
    getParentRoute: () => AuthedOnboardRoute,
  } as any)
const AuthedOrgTransactionsReimbursementsRoute =
  AuthedOrgTransactionsReimbursementsRouteImport.update({
    id: '/reimbursements',
    path: '/reimbursements',
    getParentRoute: () => AuthedOrgTransactionsRoute,
  } as any)
const AuthedOrgTransactionsCardRoute =
  AuthedOrgTransactionsCardRouteImport.update({
    id: '/card',
    path: '/card',
    getParentRoute: () => AuthedOrgTransactionsRoute,
  } as any)
const AuthedOrgTransactionsIdRoute = AuthedOrgTransactionsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthedOrgTransactionsRoute,
} as any)
const AuthedOrgTaxRefundsRoute = AuthedOrgTaxRefundsRouteImport.update({
  id: '/refunds',
  path: '/refunds',
  getParentRoute: () => AuthedOrgTaxRoute,
} as any)
const AuthedOrgSettingsProfileRoute =
  AuthedOrgSettingsProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthedOrgSettingsRoute,
  } as any)
const AuthedOrgSettingsNotificationsRoute =
  AuthedOrgSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthedOrgSettingsRoute,
  } as any)
const AuthedOrgSettingsDevelopmentRoute =
  AuthedOrgSettingsDevelopmentRouteImport.update({
    id: '/development',
    path: '/development',
    getParentRoute: () => AuthedOrgSettingsRoute,
  } as any)
const AuthedOrgSettingsBankRoute = AuthedOrgSettingsBankRouteImport.update({
  id: '/bank',
  path: '/bank',
  getParentRoute: () => AuthedOrgSettingsRoute,
} as any)
const AuthedOrgRequestsIdRoute = AuthedOrgRequestsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthedOrgRequestsRoute,
} as any)
const AuthedOrgReferralsSendRoute = AuthedOrgReferralsSendRouteImport.update({
  id: '/send',
  path: '/send',
  getParentRoute: () => AuthedOrgReferralsRoute,
} as any)
const AuthedOrgReferralsHowItWorksRoute =
  AuthedOrgReferralsHowItWorksRouteImport.update({
    id: '/how-it-works',
    path: '/how-it-works',
    getParentRoute: () => AuthedOrgReferralsRoute,
  } as any)
const AuthedOrgPoliciesExpenseRoute =
  AuthedOrgPoliciesExpenseRouteImport.update({
    id: '/expense',
    path: '/expense',
    getParentRoute: () => AuthedOrgPoliciesRoute,
  } as any)
const AuthedOrgPoliciesApprovalRoute =
  AuthedOrgPoliciesApprovalRouteImport.update({
    id: '/approval',
    path: '/approval',
    getParentRoute: () => AuthedOrgPoliciesRoute,
  } as any)
const AuthedOrgOrganizationStatementsRoute =
  AuthedOrgOrganizationStatementsRouteImport.update({
    id: '/statements',
    path: '/statements',
    getParentRoute: () => AuthedOrgOrganizationRoute,
  } as any)
const AuthedOrgOrganizationPeopleRoute =
  AuthedOrgOrganizationPeopleRouteImport.update({
    id: '/people',
    path: '/people',
    getParentRoute: () => AuthedOrgOrganizationRoute,
  } as any)
const AuthedOrgCardsCreateRoute = AuthedOrgCardsCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AuthedOrgCardsRoute,
} as any)
const AuthedOrgCardsIdRoute = AuthedOrgCardsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthedOrgCardsRoute,
} as any)
const AuthedOrgBudgetsCreateRoute = AuthedOrgBudgetsCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AuthedOrgBudgetsRoute,
} as any)
const AuthedOrgBudgetsGroupIdRoute = AuthedOrgBudgetsGroupIdRouteImport.update({
  id: '/$groupId',
  path: '/$groupId',
  getParentRoute: () => AuthedOrgBudgetsRoute,
} as any)
const AuthedOrgAccountingSyncHistoryRoute =
  AuthedOrgAccountingSyncHistoryRouteImport.update({
    id: '/sync-history',
    path: '/sync-history',
    getParentRoute: () => AuthedOrgAccountingRoute,
  } as any)
const AuthedOrgAccountingSettingsRoute =
  AuthedOrgAccountingSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthedOrgAccountingRoute,
  } as any)
const AuthedOnboardOnboardApprovedRoute =
  AuthedOnboardOnboardApprovedRouteImport.update({
    id: '/onboard/approved',
    path: '/onboard/approved',
    getParentRoute: () => AuthedOnboardRoute,
  } as any)
const AuthedOrgTaxIdIndexRoute = AuthedOrgTaxIdIndexRouteImport.update({
  id: '/$id/',
  path: '/$id/',
  getParentRoute: () => AuthedOrgTaxRoute,
} as any)
const AuthedOrgSettingsChangePhoneIndexRoute =
  AuthedOrgSettingsChangePhoneIndexRouteImport.update({
    id: '/change-phone/',
    path: '/change-phone/',
    getParentRoute: () => AuthedOrgSettingsRoute,
  } as any)
const AuthedOrgSettingsChangeEmailIndexRoute =
  AuthedOrgSettingsChangeEmailIndexRouteImport.update({
    id: '/change-email/',
    path: '/change-email/',
    getParentRoute: () => AuthedOrgSettingsRoute,
  } as any)
const AuthedOrgRequestsIdIndexRoute =
  AuthedOrgRequestsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedOrgRequestsIdRoute,
  } as any)
const AuthedOrgOrganizationSettingsIndexRoute =
  AuthedOrgOrganizationSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthedOrgOrganizationRoute,
  } as any)
const AuthedOrgCardsIdIndexRoute = AuthedOrgCardsIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedOrgCardsIdRoute,
} as any)
const AuthedOrgBudgetsGroupIdIndexRoute =
  AuthedOrgBudgetsGroupIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedOrgBudgetsGroupIdRoute,
  } as any)
const AuthedOrgAccountingIdIndexRoute =
  AuthedOrgAccountingIdIndexRouteImport.update({
    id: '/$id/',
    path: '/$id/',
    getParentRoute: () => AuthedOrgAccountingRoute,
  } as any)
const AuthedOrgTransactionsReimbursementsSettingsRoute =
  AuthedOrgTransactionsReimbursementsSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthedOrgTransactionsReimbursementsRoute,
  } as any)
const AuthedOrgTransactionsReimbursementsCreateRoute =
  AuthedOrgTransactionsReimbursementsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthedOrgTransactionsReimbursementsRoute,
  } as any)
const AuthedOrgTransactionsReimbursementsIdRoute =
  AuthedOrgTransactionsReimbursementsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthedOrgTransactionsReimbursementsRoute,
  } as any)
const AuthedOrgTransactionsCardIdRoute =
  AuthedOrgTransactionsCardIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthedOrgTransactionsCardRoute,
  } as any)
const AuthedOrgSettingsChangePhoneConfirmRoute =
  AuthedOrgSettingsChangePhoneConfirmRouteImport.update({
    id: '/change-phone/confirm',
    path: '/change-phone/confirm',
    getParentRoute: () => AuthedOrgSettingsRoute,
  } as any)
const AuthedOrgSettingsChangeEmailConfirmRoute =
  AuthedOrgSettingsChangeEmailConfirmRouteImport.update({
    id: '/change-email/confirm',
    path: '/change-email/confirm',
    getParentRoute: () => AuthedOrgSettingsRoute,
  } as any)
const AuthedOrgRequestsCreateLimitIncreaseRoute =
  AuthedOrgRequestsCreateLimitIncreaseRouteImport.update({
    id: '/create/limit-increase',
    path: '/create/limit-increase',
    getParentRoute: () => AuthedOrgRequestsRoute,
  } as any)
const AuthedOrgRequestsCreateCardRoute =
  AuthedOrgRequestsCreateCardRouteImport.update({
    id: '/create/card',
    path: '/create/card',
    getParentRoute: () => AuthedOrgRequestsRoute,
  } as any)
const AuthedOrgRequestsIdEditRoute = AuthedOrgRequestsIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => AuthedOrgRequestsIdRoute,
} as any)
const AuthedOrgPoliciesExpenseCreateRoute =
  AuthedOrgPoliciesExpenseCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthedOrgPoliciesExpenseRoute,
  } as any)
const AuthedOrgPoliciesApprovalCreateRoute =
  AuthedOrgPoliciesApprovalCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthedOrgPoliciesApprovalRoute,
  } as any)
const AuthedOrgOrganizationPeopleInvitationsRoute =
  AuthedOrgOrganizationPeopleInvitationsRouteImport.update({
    id: '/invitations',
    path: '/invitations',
    getParentRoute: () => AuthedOrgOrganizationPeopleRoute,
  } as any)
const AuthedOrgOrganizationPeopleAllRoute =
  AuthedOrgOrganizationPeopleAllRouteImport.update({
    id: '/all',
    path: '/all',
    getParentRoute: () => AuthedOrgOrganizationPeopleRoute,
  } as any)
const AuthedOrgCardsIdTransactionsRoute =
  AuthedOrgCardsIdTransactionsRouteImport.update({
    id: '/transactions',
    path: '/transactions',
    getParentRoute: () => AuthedOrgCardsIdRoute,
  } as any)
const AuthedOrgCardsIdEditRoute = AuthedOrgCardsIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => AuthedOrgCardsIdRoute,
} as any)
const AuthedOrgCardsIdActivityRoute =
  AuthedOrgCardsIdActivityRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => AuthedOrgCardsIdRoute,
  } as any)
const AuthedOrgBudgetsGroupIdReportingRoute =
  AuthedOrgBudgetsGroupIdReportingRouteImport.update({
    id: '/reporting',
    path: '/reporting',
    getParentRoute: () => AuthedOrgBudgetsGroupIdRoute,
  } as any)
const AuthedOrgBudgetsGroupIdEditRoute =
  AuthedOrgBudgetsGroupIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthedOrgBudgetsGroupIdRoute,
  } as any)
const AuthedOrgAccountingSyncHistoryIdRoute =
  AuthedOrgAccountingSyncHistoryIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthedOrgAccountingSyncHistoryRoute,
  } as any)
const AuthedOrgAccountingSettingsRulesRoute =
  AuthedOrgAccountingSettingsRulesRouteImport.update({
    id: '/rules',
    path: '/rules',
    getParentRoute: () => AuthedOrgAccountingSettingsRoute,
  } as any)
const AuthedOrgAccountingSettingsFieldsRoute =
  AuthedOrgAccountingSettingsFieldsRouteImport.update({
    id: '/fields',
    path: '/fields',
    getParentRoute: () => AuthedOrgAccountingSettingsRoute,
  } as any)
const AuthedOrgPoliciesExpenseIdEditRoute =
  AuthedOrgPoliciesExpenseIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => AuthedOrgPoliciesExpenseRoute,
  } as any)
const AuthedOrgPoliciesApprovalIdEditRoute =
  AuthedOrgPoliciesApprovalIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => AuthedOrgPoliciesApprovalRoute,
  } as any)
const AuthedOrgAccountingSettingsFieldsIdRoute =
  AuthedOrgAccountingSettingsFieldsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthedOrgAccountingSettingsFieldsRoute,
  } as any)
const AuthedOrgOrganizationPeopleAllIdIndexRoute =
  AuthedOrgOrganizationPeopleAllIdIndexRouteImport.update({
    id: '/$id/',
    path: '/$id/',
    getParentRoute: () => AuthedOrgOrganizationPeopleAllRoute,
  } as any)
const AuthedOrgOrganizationPeopleAllIdEditRoleRoute =
  AuthedOrgOrganizationPeopleAllIdEditRoleRouteImport.update({
    id: '/$id/edit-role',
    path: '/$id/edit-role',
    getParentRoute: () => AuthedOrgOrganizationPeopleAllRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/create-organization': typeof AuthedCreateOrganizationRoute
  '/email-verified': typeof UnauthedEmailVerifiedRoute
  '/forgot-password': typeof UnauthedForgotPasswordRoute
  '/login': typeof UnauthedLoginRouteWithChildren
  '/reset-password': typeof UnauthedResetPasswordRoute
  '/sign-up': typeof UnauthedSignUpRoute
  '/verify-email': typeof UnauthedVerifyEmailRoute
  '/join/$id': typeof JoinIdRoute
  '/transparency/$orgId': typeof TransparencyOrgIdRoute
  '/accounting': typeof AuthedOrgAccountingRouteWithChildren
  '/bill-pay': typeof AuthedOrgBillPayRoute
  '/budgets': typeof AuthedOrgBudgetsRouteWithChildren
  '/cards': typeof AuthedOrgCardsRouteWithChildren
  '/dashboard': typeof AuthedOrgDashboardRoute
  '/insights': typeof AuthedOrgInsightsRoute
  '/organization': typeof AuthedOrgOrganizationRouteWithChildren
  '/policies': typeof AuthedOrgPoliciesRouteWithChildren
  '/referrals': typeof AuthedOrgReferralsRouteWithChildren
  '/requests': typeof AuthedOrgRequestsRouteWithChildren
  '/settings': typeof AuthedOrgSettingsRouteWithChildren
  '/tax': typeof AuthedOrgTaxRouteWithChildren
  '/tax-setup': typeof AuthedOrgTaxSetupRoute
  '/test': typeof AuthedOrgTestRoute
  '/transactions': typeof AuthedOrgTransactionsRouteWithChildren
  '/login/2fa': typeof UnauthedLogin2faRoute
  '/login/': typeof UnauthedLoginIndexRoute
  '/onboard/approved': typeof AuthedOnboardOnboardApprovedRoute
  '/accounting/settings': typeof AuthedOrgAccountingSettingsRouteWithChildren
  '/accounting/sync-history': typeof AuthedOrgAccountingSyncHistoryRouteWithChildren
  '/budgets/$groupId': typeof AuthedOrgBudgetsGroupIdRouteWithChildren
  '/budgets/create': typeof AuthedOrgBudgetsCreateRoute
  '/cards/$id': typeof AuthedOrgCardsIdRouteWithChildren
  '/cards/create': typeof AuthedOrgCardsCreateRoute
  '/organization/people': typeof AuthedOrgOrganizationPeopleRouteWithChildren
  '/organization/statements': typeof AuthedOrgOrganizationStatementsRoute
  '/policies/approval': typeof AuthedOrgPoliciesApprovalRouteWithChildren
  '/policies/expense': typeof AuthedOrgPoliciesExpenseRouteWithChildren
  '/referrals/how-it-works': typeof AuthedOrgReferralsHowItWorksRoute
  '/referrals/send': typeof AuthedOrgReferralsSendRoute
  '/requests/$id': typeof AuthedOrgRequestsIdRouteWithChildren
  '/settings/bank': typeof AuthedOrgSettingsBankRoute
  '/settings/development': typeof AuthedOrgSettingsDevelopmentRoute
  '/settings/notifications': typeof AuthedOrgSettingsNotificationsRoute
  '/settings/profile': typeof AuthedOrgSettingsProfileRoute
  '/tax/refunds': typeof AuthedOrgTaxRefundsRoute
  '/transactions/$id': typeof AuthedOrgTransactionsIdRoute
  '/transactions/card': typeof AuthedOrgTransactionsCardRouteWithChildren
  '/transactions/reimbursements': typeof AuthedOrgTransactionsReimbursementsRouteWithChildren
  '/onboard': typeof AuthedOnboardOnboardIndexRoute
  '/accounting-setup': typeof AuthedOrgAccountingSetupIndexRoute
  '/organization/': typeof AuthedOrgOrganizationIndexRoute
  '/settings/': typeof AuthedOrgSettingsIndexRoute
  '/accounting/settings/fields': typeof AuthedOrgAccountingSettingsFieldsRouteWithChildren
  '/accounting/settings/rules': typeof AuthedOrgAccountingSettingsRulesRoute
  '/accounting/sync-history/$id': typeof AuthedOrgAccountingSyncHistoryIdRoute
  '/budgets/$groupId/edit': typeof AuthedOrgBudgetsGroupIdEditRoute
  '/budgets/$groupId/reporting': typeof AuthedOrgBudgetsGroupIdReportingRoute
  '/cards/$id/activity': typeof AuthedOrgCardsIdActivityRoute
  '/cards/$id/edit': typeof AuthedOrgCardsIdEditRoute
  '/cards/$id/transactions': typeof AuthedOrgCardsIdTransactionsRoute
  '/organization/people/all': typeof AuthedOrgOrganizationPeopleAllRouteWithChildren
  '/organization/people/invitations': typeof AuthedOrgOrganizationPeopleInvitationsRoute
  '/policies/approval/create': typeof AuthedOrgPoliciesApprovalCreateRoute
  '/policies/expense/create': typeof AuthedOrgPoliciesExpenseCreateRoute
  '/requests/$id/edit': typeof AuthedOrgRequestsIdEditRoute
  '/requests/create/card': typeof AuthedOrgRequestsCreateCardRoute
  '/requests/create/limit-increase': typeof AuthedOrgRequestsCreateLimitIncreaseRoute
  '/settings/change-email/confirm': typeof AuthedOrgSettingsChangeEmailConfirmRoute
  '/settings/change-phone/confirm': typeof AuthedOrgSettingsChangePhoneConfirmRoute
  '/transactions/card/$id': typeof AuthedOrgTransactionsCardIdRoute
  '/transactions/reimbursements/$id': typeof AuthedOrgTransactionsReimbursementsIdRoute
  '/transactions/reimbursements/create': typeof AuthedOrgTransactionsReimbursementsCreateRoute
  '/transactions/reimbursements/settings': typeof AuthedOrgTransactionsReimbursementsSettingsRoute
  '/accounting/$id': typeof AuthedOrgAccountingIdIndexRoute
  '/budgets/$groupId/': typeof AuthedOrgBudgetsGroupIdIndexRoute
  '/cards/$id/': typeof AuthedOrgCardsIdIndexRoute
  '/organization/settings': typeof AuthedOrgOrganizationSettingsIndexRoute
  '/requests/$id/': typeof AuthedOrgRequestsIdIndexRoute
  '/settings/change-email': typeof AuthedOrgSettingsChangeEmailIndexRoute
  '/settings/change-phone': typeof AuthedOrgSettingsChangePhoneIndexRoute
  '/tax/$id': typeof AuthedOrgTaxIdIndexRoute
  '/accounting/settings/fields/$id': typeof AuthedOrgAccountingSettingsFieldsIdRoute
  '/policies/approval/$id/edit': typeof AuthedOrgPoliciesApprovalIdEditRoute
  '/policies/expense/$id/edit': typeof AuthedOrgPoliciesExpenseIdEditRoute
  '/organization/people/all/$id/edit-role': typeof AuthedOrgOrganizationPeopleAllIdEditRoleRoute
  '/organization/people/all/$id': typeof AuthedOrgOrganizationPeopleAllIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/create-organization': typeof AuthedCreateOrganizationRoute
  '/email-verified': typeof UnauthedEmailVerifiedRoute
  '/forgot-password': typeof UnauthedForgotPasswordRoute
  '/reset-password': typeof UnauthedResetPasswordRoute
  '/sign-up': typeof UnauthedSignUpRoute
  '/verify-email': typeof UnauthedVerifyEmailRoute
  '/join/$id': typeof JoinIdRoute
  '/transparency/$orgId': typeof TransparencyOrgIdRoute
  '/accounting': typeof AuthedOrgAccountingRouteWithChildren
  '/bill-pay': typeof AuthedOrgBillPayRoute
  '/budgets': typeof AuthedOrgBudgetsRouteWithChildren
  '/cards': typeof AuthedOrgCardsRouteWithChildren
  '/dashboard': typeof AuthedOrgDashboardRoute
  '/insights': typeof AuthedOrgInsightsRoute
  '/policies': typeof AuthedOrgPoliciesRouteWithChildren
  '/referrals': typeof AuthedOrgReferralsRouteWithChildren
  '/requests': typeof AuthedOrgRequestsRouteWithChildren
  '/tax': typeof AuthedOrgTaxRouteWithChildren
  '/tax-setup': typeof AuthedOrgTaxSetupRoute
  '/test': typeof AuthedOrgTestRoute
  '/transactions': typeof AuthedOrgTransactionsRouteWithChildren
  '/login/2fa': typeof UnauthedLogin2faRoute
  '/login': typeof UnauthedLoginIndexRoute
  '/onboard/approved': typeof AuthedOnboardOnboardApprovedRoute
  '/accounting/settings': typeof AuthedOrgAccountingSettingsRouteWithChildren
  '/accounting/sync-history': typeof AuthedOrgAccountingSyncHistoryRouteWithChildren
  '/budgets/create': typeof AuthedOrgBudgetsCreateRoute
  '/cards/create': typeof AuthedOrgCardsCreateRoute
  '/organization/people': typeof AuthedOrgOrganizationPeopleRouteWithChildren
  '/organization/statements': typeof AuthedOrgOrganizationStatementsRoute
  '/policies/approval': typeof AuthedOrgPoliciesApprovalRouteWithChildren
  '/policies/expense': typeof AuthedOrgPoliciesExpenseRouteWithChildren
  '/referrals/how-it-works': typeof AuthedOrgReferralsHowItWorksRoute
  '/referrals/send': typeof AuthedOrgReferralsSendRoute
  '/settings/bank': typeof AuthedOrgSettingsBankRoute
  '/settings/development': typeof AuthedOrgSettingsDevelopmentRoute
  '/settings/notifications': typeof AuthedOrgSettingsNotificationsRoute
  '/settings/profile': typeof AuthedOrgSettingsProfileRoute
  '/tax/refunds': typeof AuthedOrgTaxRefundsRoute
  '/transactions/$id': typeof AuthedOrgTransactionsIdRoute
  '/transactions/card': typeof AuthedOrgTransactionsCardRouteWithChildren
  '/transactions/reimbursements': typeof AuthedOrgTransactionsReimbursementsRouteWithChildren
  '/onboard': typeof AuthedOnboardOnboardIndexRoute
  '/accounting-setup': typeof AuthedOrgAccountingSetupIndexRoute
  '/organization': typeof AuthedOrgOrganizationIndexRoute
  '/settings': typeof AuthedOrgSettingsIndexRoute
  '/accounting/settings/fields': typeof AuthedOrgAccountingSettingsFieldsRouteWithChildren
  '/accounting/settings/rules': typeof AuthedOrgAccountingSettingsRulesRoute
  '/accounting/sync-history/$id': typeof AuthedOrgAccountingSyncHistoryIdRoute
  '/budgets/$groupId/edit': typeof AuthedOrgBudgetsGroupIdEditRoute
  '/budgets/$groupId/reporting': typeof AuthedOrgBudgetsGroupIdReportingRoute
  '/cards/$id/activity': typeof AuthedOrgCardsIdActivityRoute
  '/cards/$id/edit': typeof AuthedOrgCardsIdEditRoute
  '/cards/$id/transactions': typeof AuthedOrgCardsIdTransactionsRoute
  '/organization/people/all': typeof AuthedOrgOrganizationPeopleAllRouteWithChildren
  '/organization/people/invitations': typeof AuthedOrgOrganizationPeopleInvitationsRoute
  '/policies/approval/create': typeof AuthedOrgPoliciesApprovalCreateRoute
  '/policies/expense/create': typeof AuthedOrgPoliciesExpenseCreateRoute
  '/requests/$id/edit': typeof AuthedOrgRequestsIdEditRoute
  '/requests/create/card': typeof AuthedOrgRequestsCreateCardRoute
  '/requests/create/limit-increase': typeof AuthedOrgRequestsCreateLimitIncreaseRoute
  '/settings/change-email/confirm': typeof AuthedOrgSettingsChangeEmailConfirmRoute
  '/settings/change-phone/confirm': typeof AuthedOrgSettingsChangePhoneConfirmRoute
  '/transactions/card/$id': typeof AuthedOrgTransactionsCardIdRoute
  '/transactions/reimbursements/$id': typeof AuthedOrgTransactionsReimbursementsIdRoute
  '/transactions/reimbursements/create': typeof AuthedOrgTransactionsReimbursementsCreateRoute
  '/transactions/reimbursements/settings': typeof AuthedOrgTransactionsReimbursementsSettingsRoute
  '/accounting/$id': typeof AuthedOrgAccountingIdIndexRoute
  '/budgets/$groupId': typeof AuthedOrgBudgetsGroupIdIndexRoute
  '/cards/$id': typeof AuthedOrgCardsIdIndexRoute
  '/organization/settings': typeof AuthedOrgOrganizationSettingsIndexRoute
  '/requests/$id': typeof AuthedOrgRequestsIdIndexRoute
  '/settings/change-email': typeof AuthedOrgSettingsChangeEmailIndexRoute
  '/settings/change-phone': typeof AuthedOrgSettingsChangePhoneIndexRoute
  '/tax/$id': typeof AuthedOrgTaxIdIndexRoute
  '/accounting/settings/fields/$id': typeof AuthedOrgAccountingSettingsFieldsIdRoute
  '/policies/approval/$id/edit': typeof AuthedOrgPoliciesApprovalIdEditRoute
  '/policies/expense/$id/edit': typeof AuthedOrgPoliciesExpenseIdEditRoute
  '/organization/people/all/$id/edit-role': typeof AuthedOrgOrganizationPeopleAllIdEditRoleRoute
  '/organization/people/all/$id': typeof AuthedOrgOrganizationPeopleAllIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/_unauthed': typeof UnauthedRouteWithChildren
  '/_authed/_onboard': typeof AuthedOnboardRouteWithChildren
  '/_authed/_org': typeof AuthedOrgRouteWithChildren
  '/_authed/create-organization': typeof AuthedCreateOrganizationRoute
  '/_unauthed/email-verified': typeof UnauthedEmailVerifiedRoute
  '/_unauthed/forgot-password': typeof UnauthedForgotPasswordRoute
  '/_unauthed/login': typeof UnauthedLoginRouteWithChildren
  '/_unauthed/reset-password': typeof UnauthedResetPasswordRoute
  '/_unauthed/sign-up': typeof UnauthedSignUpRoute
  '/_unauthed/verify-email': typeof UnauthedVerifyEmailRoute
  '/join/$id': typeof JoinIdRoute
  '/transparency/$orgId': typeof TransparencyOrgIdRoute
  '/_authed/_org/accounting': typeof AuthedOrgAccountingRouteWithChildren
  '/_authed/_org/bill-pay': typeof AuthedOrgBillPayRoute
  '/_authed/_org/budgets': typeof AuthedOrgBudgetsRouteWithChildren
  '/_authed/_org/cards': typeof AuthedOrgCardsRouteWithChildren
  '/_authed/_org/dashboard': typeof AuthedOrgDashboardRoute
  '/_authed/_org/insights': typeof AuthedOrgInsightsRoute
  '/_authed/_org/organization': typeof AuthedOrgOrganizationRouteWithChildren
  '/_authed/_org/policies': typeof AuthedOrgPoliciesRouteWithChildren
  '/_authed/_org/referrals': typeof AuthedOrgReferralsRouteWithChildren
  '/_authed/_org/requests': typeof AuthedOrgRequestsRouteWithChildren
  '/_authed/_org/settings': typeof AuthedOrgSettingsRouteWithChildren
  '/_authed/_org/tax': typeof AuthedOrgTaxRouteWithChildren
  '/_authed/_org/tax-setup': typeof AuthedOrgTaxSetupRoute
  '/_authed/_org/test': typeof AuthedOrgTestRoute
  '/_authed/_org/transactions': typeof AuthedOrgTransactionsRouteWithChildren
  '/_unauthed/login/2fa': typeof UnauthedLogin2faRoute
  '/_unauthed/login/': typeof UnauthedLoginIndexRoute
  '/_authed/_onboard/onboard/approved': typeof AuthedOnboardOnboardApprovedRoute
  '/_authed/_org/accounting/settings': typeof AuthedOrgAccountingSettingsRouteWithChildren
  '/_authed/_org/accounting/sync-history': typeof AuthedOrgAccountingSyncHistoryRouteWithChildren
  '/_authed/_org/budgets/$groupId': typeof AuthedOrgBudgetsGroupIdRouteWithChildren
  '/_authed/_org/budgets/create': typeof AuthedOrgBudgetsCreateRoute
  '/_authed/_org/cards/$id': typeof AuthedOrgCardsIdRouteWithChildren
  '/_authed/_org/cards/create': typeof AuthedOrgCardsCreateRoute
  '/_authed/_org/organization/people': typeof AuthedOrgOrganizationPeopleRouteWithChildren
  '/_authed/_org/organization/statements': typeof AuthedOrgOrganizationStatementsRoute
  '/_authed/_org/policies/approval': typeof AuthedOrgPoliciesApprovalRouteWithChildren
  '/_authed/_org/policies/expense': typeof AuthedOrgPoliciesExpenseRouteWithChildren
  '/_authed/_org/referrals/how-it-works': typeof AuthedOrgReferralsHowItWorksRoute
  '/_authed/_org/referrals/send': typeof AuthedOrgReferralsSendRoute
  '/_authed/_org/requests/$id': typeof AuthedOrgRequestsIdRouteWithChildren
  '/_authed/_org/settings/bank': typeof AuthedOrgSettingsBankRoute
  '/_authed/_org/settings/development': typeof AuthedOrgSettingsDevelopmentRoute
  '/_authed/_org/settings/notifications': typeof AuthedOrgSettingsNotificationsRoute
  '/_authed/_org/settings/profile': typeof AuthedOrgSettingsProfileRoute
  '/_authed/_org/tax/refunds': typeof AuthedOrgTaxRefundsRoute
  '/_authed/_org/transactions/$id': typeof AuthedOrgTransactionsIdRoute
  '/_authed/_org/transactions/card': typeof AuthedOrgTransactionsCardRouteWithChildren
  '/_authed/_org/transactions/reimbursements': typeof AuthedOrgTransactionsReimbursementsRouteWithChildren
  '/_authed/_onboard/onboard/': typeof AuthedOnboardOnboardIndexRoute
  '/_authed/_org/accounting-setup/': typeof AuthedOrgAccountingSetupIndexRoute
  '/_authed/_org/organization/': typeof AuthedOrgOrganizationIndexRoute
  '/_authed/_org/settings/': typeof AuthedOrgSettingsIndexRoute
  '/_authed/_org/accounting/settings/fields': typeof AuthedOrgAccountingSettingsFieldsRouteWithChildren
  '/_authed/_org/accounting/settings/rules': typeof AuthedOrgAccountingSettingsRulesRoute
  '/_authed/_org/accounting/sync-history/$id': typeof AuthedOrgAccountingSyncHistoryIdRoute
  '/_authed/_org/budgets/$groupId/edit': typeof AuthedOrgBudgetsGroupIdEditRoute
  '/_authed/_org/budgets/$groupId/reporting': typeof AuthedOrgBudgetsGroupIdReportingRoute
  '/_authed/_org/cards/$id/activity': typeof AuthedOrgCardsIdActivityRoute
  '/_authed/_org/cards/$id/edit': typeof AuthedOrgCardsIdEditRoute
  '/_authed/_org/cards/$id/transactions': typeof AuthedOrgCardsIdTransactionsRoute
  '/_authed/_org/organization/people/all': typeof AuthedOrgOrganizationPeopleAllRouteWithChildren
  '/_authed/_org/organization/people/invitations': typeof AuthedOrgOrganizationPeopleInvitationsRoute
  '/_authed/_org/policies/approval/create': typeof AuthedOrgPoliciesApprovalCreateRoute
  '/_authed/_org/policies/expense/create': typeof AuthedOrgPoliciesExpenseCreateRoute
  '/_authed/_org/requests/$id/edit': typeof AuthedOrgRequestsIdEditRoute
  '/_authed/_org/requests/create/card': typeof AuthedOrgRequestsCreateCardRoute
  '/_authed/_org/requests/create/limit-increase': typeof AuthedOrgRequestsCreateLimitIncreaseRoute
  '/_authed/_org/settings/change-email/confirm': typeof AuthedOrgSettingsChangeEmailConfirmRoute
  '/_authed/_org/settings/change-phone/confirm': typeof AuthedOrgSettingsChangePhoneConfirmRoute
  '/_authed/_org/transactions/card/$id': typeof AuthedOrgTransactionsCardIdRoute
  '/_authed/_org/transactions/reimbursements/$id': typeof AuthedOrgTransactionsReimbursementsIdRoute
  '/_authed/_org/transactions/reimbursements/create': typeof AuthedOrgTransactionsReimbursementsCreateRoute
  '/_authed/_org/transactions/reimbursements/settings': typeof AuthedOrgTransactionsReimbursementsSettingsRoute
  '/_authed/_org/accounting/$id/': typeof AuthedOrgAccountingIdIndexRoute
  '/_authed/_org/budgets/$groupId/': typeof AuthedOrgBudgetsGroupIdIndexRoute
  '/_authed/_org/cards/$id/': typeof AuthedOrgCardsIdIndexRoute
  '/_authed/_org/organization/settings/': typeof AuthedOrgOrganizationSettingsIndexRoute
  '/_authed/_org/requests/$id/': typeof AuthedOrgRequestsIdIndexRoute
  '/_authed/_org/settings/change-email/': typeof AuthedOrgSettingsChangeEmailIndexRoute
  '/_authed/_org/settings/change-phone/': typeof AuthedOrgSettingsChangePhoneIndexRoute
  '/_authed/_org/tax/$id/': typeof AuthedOrgTaxIdIndexRoute
  '/_authed/_org/accounting/settings/fields/$id': typeof AuthedOrgAccountingSettingsFieldsIdRoute
  '/_authed/_org/policies/approval/$id/edit': typeof AuthedOrgPoliciesApprovalIdEditRoute
  '/_authed/_org/policies/expense/$id/edit': typeof AuthedOrgPoliciesExpenseIdEditRoute
  '/_authed/_org/organization/people/all/$id/edit-role': typeof AuthedOrgOrganizationPeopleAllIdEditRoleRoute
  '/_authed/_org/organization/people/all/$id/': typeof AuthedOrgOrganizationPeopleAllIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/create-organization'
    | '/email-verified'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/sign-up'
    | '/verify-email'
    | '/join/$id'
    | '/transparency/$orgId'
    | '/accounting'
    | '/bill-pay'
    | '/budgets'
    | '/cards'
    | '/dashboard'
    | '/insights'
    | '/organization'
    | '/policies'
    | '/referrals'
    | '/requests'
    | '/settings'
    | '/tax'
    | '/tax-setup'
    | '/test'
    | '/transactions'
    | '/login/2fa'
    | '/login/'
    | '/onboard/approved'
    | '/accounting/settings'
    | '/accounting/sync-history'
    | '/budgets/$groupId'
    | '/budgets/create'
    | '/cards/$id'
    | '/cards/create'
    | '/organization/people'
    | '/organization/statements'
    | '/policies/approval'
    | '/policies/expense'
    | '/referrals/how-it-works'
    | '/referrals/send'
    | '/requests/$id'
    | '/settings/bank'
    | '/settings/development'
    | '/settings/notifications'
    | '/settings/profile'
    | '/tax/refunds'
    | '/transactions/$id'
    | '/transactions/card'
    | '/transactions/reimbursements'
    | '/onboard'
    | '/accounting-setup'
    | '/organization/'
    | '/settings/'
    | '/accounting/settings/fields'
    | '/accounting/settings/rules'
    | '/accounting/sync-history/$id'
    | '/budgets/$groupId/edit'
    | '/budgets/$groupId/reporting'
    | '/cards/$id/activity'
    | '/cards/$id/edit'
    | '/cards/$id/transactions'
    | '/organization/people/all'
    | '/organization/people/invitations'
    | '/policies/approval/create'
    | '/policies/expense/create'
    | '/requests/$id/edit'
    | '/requests/create/card'
    | '/requests/create/limit-increase'
    | '/settings/change-email/confirm'
    | '/settings/change-phone/confirm'
    | '/transactions/card/$id'
    | '/transactions/reimbursements/$id'
    | '/transactions/reimbursements/create'
    | '/transactions/reimbursements/settings'
    | '/accounting/$id'
    | '/budgets/$groupId/'
    | '/cards/$id/'
    | '/organization/settings'
    | '/requests/$id/'
    | '/settings/change-email'
    | '/settings/change-phone'
    | '/tax/$id'
    | '/accounting/settings/fields/$id'
    | '/policies/approval/$id/edit'
    | '/policies/expense/$id/edit'
    | '/organization/people/all/$id/edit-role'
    | '/organization/people/all/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/create-organization'
    | '/email-verified'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-up'
    | '/verify-email'
    | '/join/$id'
    | '/transparency/$orgId'
    | '/accounting'
    | '/bill-pay'
    | '/budgets'
    | '/cards'
    | '/dashboard'
    | '/insights'
    | '/policies'
    | '/referrals'
    | '/requests'
    | '/tax'
    | '/tax-setup'
    | '/test'
    | '/transactions'
    | '/login/2fa'
    | '/login'
    | '/onboard/approved'
    | '/accounting/settings'
    | '/accounting/sync-history'
    | '/budgets/create'
    | '/cards/create'
    | '/organization/people'
    | '/organization/statements'
    | '/policies/approval'
    | '/policies/expense'
    | '/referrals/how-it-works'
    | '/referrals/send'
    | '/settings/bank'
    | '/settings/development'
    | '/settings/notifications'
    | '/settings/profile'
    | '/tax/refunds'
    | '/transactions/$id'
    | '/transactions/card'
    | '/transactions/reimbursements'
    | '/onboard'
    | '/accounting-setup'
    | '/organization'
    | '/settings'
    | '/accounting/settings/fields'
    | '/accounting/settings/rules'
    | '/accounting/sync-history/$id'
    | '/budgets/$groupId/edit'
    | '/budgets/$groupId/reporting'
    | '/cards/$id/activity'
    | '/cards/$id/edit'
    | '/cards/$id/transactions'
    | '/organization/people/all'
    | '/organization/people/invitations'
    | '/policies/approval/create'
    | '/policies/expense/create'
    | '/requests/$id/edit'
    | '/requests/create/card'
    | '/requests/create/limit-increase'
    | '/settings/change-email/confirm'
    | '/settings/change-phone/confirm'
    | '/transactions/card/$id'
    | '/transactions/reimbursements/$id'
    | '/transactions/reimbursements/create'
    | '/transactions/reimbursements/settings'
    | '/accounting/$id'
    | '/budgets/$groupId'
    | '/cards/$id'
    | '/organization/settings'
    | '/requests/$id'
    | '/settings/change-email'
    | '/settings/change-phone'
    | '/tax/$id'
    | '/accounting/settings/fields/$id'
    | '/policies/approval/$id/edit'
    | '/policies/expense/$id/edit'
    | '/organization/people/all/$id/edit-role'
    | '/organization/people/all/$id'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/_unauthed'
    | '/_authed/_onboard'
    | '/_authed/_org'
    | '/_authed/create-organization'
    | '/_unauthed/email-verified'
    | '/_unauthed/forgot-password'
    | '/_unauthed/login'
    | '/_unauthed/reset-password'
    | '/_unauthed/sign-up'
    | '/_unauthed/verify-email'
    | '/join/$id'
    | '/transparency/$orgId'
    | '/_authed/_org/accounting'
    | '/_authed/_org/bill-pay'
    | '/_authed/_org/budgets'
    | '/_authed/_org/cards'
    | '/_authed/_org/dashboard'
    | '/_authed/_org/insights'
    | '/_authed/_org/organization'
    | '/_authed/_org/policies'
    | '/_authed/_org/referrals'
    | '/_authed/_org/requests'
    | '/_authed/_org/settings'
    | '/_authed/_org/tax'
    | '/_authed/_org/tax-setup'
    | '/_authed/_org/test'
    | '/_authed/_org/transactions'
    | '/_unauthed/login/2fa'
    | '/_unauthed/login/'
    | '/_authed/_onboard/onboard/approved'
    | '/_authed/_org/accounting/settings'
    | '/_authed/_org/accounting/sync-history'
    | '/_authed/_org/budgets/$groupId'
    | '/_authed/_org/budgets/create'
    | '/_authed/_org/cards/$id'
    | '/_authed/_org/cards/create'
    | '/_authed/_org/organization/people'
    | '/_authed/_org/organization/statements'
    | '/_authed/_org/policies/approval'
    | '/_authed/_org/policies/expense'
    | '/_authed/_org/referrals/how-it-works'
    | '/_authed/_org/referrals/send'
    | '/_authed/_org/requests/$id'
    | '/_authed/_org/settings/bank'
    | '/_authed/_org/settings/development'
    | '/_authed/_org/settings/notifications'
    | '/_authed/_org/settings/profile'
    | '/_authed/_org/tax/refunds'
    | '/_authed/_org/transactions/$id'
    | '/_authed/_org/transactions/card'
    | '/_authed/_org/transactions/reimbursements'
    | '/_authed/_onboard/onboard/'
    | '/_authed/_org/accounting-setup/'
    | '/_authed/_org/organization/'
    | '/_authed/_org/settings/'
    | '/_authed/_org/accounting/settings/fields'
    | '/_authed/_org/accounting/settings/rules'
    | '/_authed/_org/accounting/sync-history/$id'
    | '/_authed/_org/budgets/$groupId/edit'
    | '/_authed/_org/budgets/$groupId/reporting'
    | '/_authed/_org/cards/$id/activity'
    | '/_authed/_org/cards/$id/edit'
    | '/_authed/_org/cards/$id/transactions'
    | '/_authed/_org/organization/people/all'
    | '/_authed/_org/organization/people/invitations'
    | '/_authed/_org/policies/approval/create'
    | '/_authed/_org/policies/expense/create'
    | '/_authed/_org/requests/$id/edit'
    | '/_authed/_org/requests/create/card'
    | '/_authed/_org/requests/create/limit-increase'
    | '/_authed/_org/settings/change-email/confirm'
    | '/_authed/_org/settings/change-phone/confirm'
    | '/_authed/_org/transactions/card/$id'
    | '/_authed/_org/transactions/reimbursements/$id'
    | '/_authed/_org/transactions/reimbursements/create'
    | '/_authed/_org/transactions/reimbursements/settings'
    | '/_authed/_org/accounting/$id/'
    | '/_authed/_org/budgets/$groupId/'
    | '/_authed/_org/cards/$id/'
    | '/_authed/_org/organization/settings/'
    | '/_authed/_org/requests/$id/'
    | '/_authed/_org/settings/change-email/'
    | '/_authed/_org/settings/change-phone/'
    | '/_authed/_org/tax/$id/'
    | '/_authed/_org/accounting/settings/fields/$id'
    | '/_authed/_org/policies/approval/$id/edit'
    | '/_authed/_org/policies/expense/$id/edit'
    | '/_authed/_org/organization/people/all/$id/edit-role'
    | '/_authed/_org/organization/people/all/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  UnauthedRoute: typeof UnauthedRouteWithChildren
  JoinIdRoute: typeof JoinIdRoute
  TransparencyOrgIdRoute: typeof TransparencyOrgIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_unauthed': {
      id: '/_unauthed'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof UnauthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/transparency/$orgId': {
      id: '/transparency/$orgId'
      path: '/transparency/$orgId'
      fullPath: '/transparency/$orgId'
      preLoaderRoute: typeof TransparencyOrgIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join/$id': {
      id: '/join/$id'
      path: '/join/$id'
      fullPath: '/join/$id'
      preLoaderRoute: typeof JoinIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_unauthed/verify-email': {
      id: '/_unauthed/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof UnauthedVerifyEmailRouteImport
      parentRoute: typeof UnauthedRoute
    }
    '/_unauthed/sign-up': {
      id: '/_unauthed/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof UnauthedSignUpRouteImport
      parentRoute: typeof UnauthedRoute
    }
    '/_unauthed/reset-password': {
      id: '/_unauthed/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof UnauthedResetPasswordRouteImport
      parentRoute: typeof UnauthedRoute
    }
    '/_unauthed/login': {
      id: '/_unauthed/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof UnauthedLoginRouteImport
      parentRoute: typeof UnauthedRoute
    }
    '/_unauthed/forgot-password': {
      id: '/_unauthed/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof UnauthedForgotPasswordRouteImport
      parentRoute: typeof UnauthedRoute
    }
    '/_unauthed/email-verified': {
      id: '/_unauthed/email-verified'
      path: '/email-verified'
      fullPath: '/email-verified'
      preLoaderRoute: typeof UnauthedEmailVerifiedRouteImport
      parentRoute: typeof UnauthedRoute
    }
    '/_authed/create-organization': {
      id: '/_authed/create-organization'
      path: '/create-organization'
      fullPath: '/create-organization'
      preLoaderRoute: typeof AuthedCreateOrganizationRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/_org': {
      id: '/_authed/_org'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthedOrgRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/_onboard': {
      id: '/_authed/_onboard'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthedOnboardRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_unauthed/login/': {
      id: '/_unauthed/login/'
      path: '/'
      fullPath: '/login/'
      preLoaderRoute: typeof UnauthedLoginIndexRouteImport
      parentRoute: typeof UnauthedLoginRoute
    }
    '/_unauthed/login/2fa': {
      id: '/_unauthed/login/2fa'
      path: '/2fa'
      fullPath: '/login/2fa'
      preLoaderRoute: typeof UnauthedLogin2faRouteImport
      parentRoute: typeof UnauthedLoginRoute
    }
    '/_authed/_org/transactions': {
      id: '/_authed/_org/transactions'
      path: '/transactions'
      fullPath: '/transactions'
      preLoaderRoute: typeof AuthedOrgTransactionsRouteImport
      parentRoute: typeof AuthedOrgRoute
    }
    '/_authed/_org/test': {
      id: '/_authed/_org/test'
      path: '/test'
      fullPath: '/test'
      preLoaderRoute: typeof AuthedOrgTestRouteImport
      parentRoute: typeof AuthedOrgRoute
    }
    '/_authed/_org/tax-setup': {
      id: '/_authed/_org/tax-setup'
      path: '/tax-setup'
      fullPath: '/tax-setup'
      preLoaderRoute: typeof AuthedOrgTaxSetupRouteImport
      parentRoute: typeof AuthedOrgRoute
    }
    '/_authed/_org/tax': {
      id: '/_authed/_org/tax'
      path: '/tax'
      fullPath: '/tax'
      preLoaderRoute: typeof AuthedOrgTaxRouteImport
      parentRoute: typeof AuthedOrgRoute
    }
    '/_authed/_org/settings': {
      id: '/_authed/_org/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthedOrgSettingsRouteImport
      parentRoute: typeof AuthedOrgRoute
    }
    '/_authed/_org/requests': {
      id: '/_authed/_org/requests'
      path: '/requests'
      fullPath: '/requests'
      preLoaderRoute: typeof AuthedOrgRequestsRouteImport
      parentRoute: typeof AuthedOrgRoute
    }
    '/_authed/_org/referrals': {
      id: '/_authed/_org/referrals'
      path: '/referrals'
      fullPath: '/referrals'
      preLoaderRoute: typeof AuthedOrgReferralsRouteImport
      parentRoute: typeof AuthedOrgRoute
    }
    '/_authed/_org/policies': {
      id: '/_authed/_org/policies'
      path: '/policies'
      fullPath: '/policies'
      preLoaderRoute: typeof AuthedOrgPoliciesRouteImport
      parentRoute: typeof AuthedOrgRoute
    }
    '/_authed/_org/organization': {
      id: '/_authed/_org/organization'
      path: '/organization'
      fullPath: '/organization'
      preLoaderRoute: typeof AuthedOrgOrganizationRouteImport
      parentRoute: typeof AuthedOrgRoute
    }
    '/_authed/_org/insights': {
      id: '/_authed/_org/insights'
      path: '/insights'
      fullPath: '/insights'
      preLoaderRoute: typeof AuthedOrgInsightsRouteImport
      parentRoute: typeof AuthedOrgRoute
    }
    '/_authed/_org/dashboard': {
      id: '/_authed/_org/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthedOrgDashboardRouteImport
      parentRoute: typeof AuthedOrgRoute
    }
    '/_authed/_org/cards': {
      id: '/_authed/_org/cards'
      path: '/cards'
      fullPath: '/cards'
      preLoaderRoute: typeof AuthedOrgCardsRouteImport
      parentRoute: typeof AuthedOrgRoute
    }
    '/_authed/_org/budgets': {
      id: '/_authed/_org/budgets'
      path: '/budgets'
      fullPath: '/budgets'
      preLoaderRoute: typeof AuthedOrgBudgetsRouteImport
      parentRoute: typeof AuthedOrgRoute
    }
    '/_authed/_org/bill-pay': {
      id: '/_authed/_org/bill-pay'
      path: '/bill-pay'
      fullPath: '/bill-pay'
      preLoaderRoute: typeof AuthedOrgBillPayRouteImport
      parentRoute: typeof AuthedOrgRoute
    }
    '/_authed/_org/accounting': {
      id: '/_authed/_org/accounting'
      path: '/accounting'
      fullPath: '/accounting'
      preLoaderRoute: typeof AuthedOrgAccountingRouteImport
      parentRoute: typeof AuthedOrgRoute
    }
    '/_authed/_org/settings/': {
      id: '/_authed/_org/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthedOrgSettingsIndexRouteImport
      parentRoute: typeof AuthedOrgSettingsRoute
    }
    '/_authed/_org/organization/': {
      id: '/_authed/_org/organization/'
      path: '/'
      fullPath: '/organization/'
      preLoaderRoute: typeof AuthedOrgOrganizationIndexRouteImport
      parentRoute: typeof AuthedOrgOrganizationRoute
    }
    '/_authed/_org/accounting-setup/': {
      id: '/_authed/_org/accounting-setup/'
      path: '/accounting-setup'
      fullPath: '/accounting-setup'
      preLoaderRoute: typeof AuthedOrgAccountingSetupIndexRouteImport
      parentRoute: typeof AuthedOrgRoute
    }
    '/_authed/_onboard/onboard/': {
      id: '/_authed/_onboard/onboard/'
      path: '/onboard'
      fullPath: '/onboard'
      preLoaderRoute: typeof AuthedOnboardOnboardIndexRouteImport
      parentRoute: typeof AuthedOnboardRoute
    }
    '/_authed/_org/transactions/reimbursements': {
      id: '/_authed/_org/transactions/reimbursements'
      path: '/reimbursements'
      fullPath: '/transactions/reimbursements'
      preLoaderRoute: typeof AuthedOrgTransactionsReimbursementsRouteImport
      parentRoute: typeof AuthedOrgTransactionsRoute
    }
    '/_authed/_org/transactions/card': {
      id: '/_authed/_org/transactions/card'
      path: '/card'
      fullPath: '/transactions/card'
      preLoaderRoute: typeof AuthedOrgTransactionsCardRouteImport
      parentRoute: typeof AuthedOrgTransactionsRoute
    }
    '/_authed/_org/transactions/$id': {
      id: '/_authed/_org/transactions/$id'
      path: '/$id'
      fullPath: '/transactions/$id'
      preLoaderRoute: typeof AuthedOrgTransactionsIdRouteImport
      parentRoute: typeof AuthedOrgTransactionsRoute
    }
    '/_authed/_org/tax/refunds': {
      id: '/_authed/_org/tax/refunds'
      path: '/refunds'
      fullPath: '/tax/refunds'
      preLoaderRoute: typeof AuthedOrgTaxRefundsRouteImport
      parentRoute: typeof AuthedOrgTaxRoute
    }
    '/_authed/_org/settings/profile': {
      id: '/_authed/_org/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AuthedOrgSettingsProfileRouteImport
      parentRoute: typeof AuthedOrgSettingsRoute
    }
    '/_authed/_org/settings/notifications': {
      id: '/_authed/_org/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthedOrgSettingsNotificationsRouteImport
      parentRoute: typeof AuthedOrgSettingsRoute
    }
    '/_authed/_org/settings/development': {
      id: '/_authed/_org/settings/development'
      path: '/development'
      fullPath: '/settings/development'
      preLoaderRoute: typeof AuthedOrgSettingsDevelopmentRouteImport
      parentRoute: typeof AuthedOrgSettingsRoute
    }
    '/_authed/_org/settings/bank': {
      id: '/_authed/_org/settings/bank'
      path: '/bank'
      fullPath: '/settings/bank'
      preLoaderRoute: typeof AuthedOrgSettingsBankRouteImport
      parentRoute: typeof AuthedOrgSettingsRoute
    }
    '/_authed/_org/requests/$id': {
      id: '/_authed/_org/requests/$id'
      path: '/$id'
      fullPath: '/requests/$id'
      preLoaderRoute: typeof AuthedOrgRequestsIdRouteImport
      parentRoute: typeof AuthedOrgRequestsRoute
    }
    '/_authed/_org/referrals/send': {
      id: '/_authed/_org/referrals/send'
      path: '/send'
      fullPath: '/referrals/send'
      preLoaderRoute: typeof AuthedOrgReferralsSendRouteImport
      parentRoute: typeof AuthedOrgReferralsRoute
    }
    '/_authed/_org/referrals/how-it-works': {
      id: '/_authed/_org/referrals/how-it-works'
      path: '/how-it-works'
      fullPath: '/referrals/how-it-works'
      preLoaderRoute: typeof AuthedOrgReferralsHowItWorksRouteImport
      parentRoute: typeof AuthedOrgReferralsRoute
    }
    '/_authed/_org/policies/expense': {
      id: '/_authed/_org/policies/expense'
      path: '/expense'
      fullPath: '/policies/expense'
      preLoaderRoute: typeof AuthedOrgPoliciesExpenseRouteImport
      parentRoute: typeof AuthedOrgPoliciesRoute
    }
    '/_authed/_org/policies/approval': {
      id: '/_authed/_org/policies/approval'
      path: '/approval'
      fullPath: '/policies/approval'
      preLoaderRoute: typeof AuthedOrgPoliciesApprovalRouteImport
      parentRoute: typeof AuthedOrgPoliciesRoute
    }
    '/_authed/_org/organization/statements': {
      id: '/_authed/_org/organization/statements'
      path: '/statements'
      fullPath: '/organization/statements'
      preLoaderRoute: typeof AuthedOrgOrganizationStatementsRouteImport
      parentRoute: typeof AuthedOrgOrganizationRoute
    }
    '/_authed/_org/organization/people': {
      id: '/_authed/_org/organization/people'
      path: '/people'
      fullPath: '/organization/people'
      preLoaderRoute: typeof AuthedOrgOrganizationPeopleRouteImport
      parentRoute: typeof AuthedOrgOrganizationRoute
    }
    '/_authed/_org/cards/create': {
      id: '/_authed/_org/cards/create'
      path: '/create'
      fullPath: '/cards/create'
      preLoaderRoute: typeof AuthedOrgCardsCreateRouteImport
      parentRoute: typeof AuthedOrgCardsRoute
    }
    '/_authed/_org/cards/$id': {
      id: '/_authed/_org/cards/$id'
      path: '/$id'
      fullPath: '/cards/$id'
      preLoaderRoute: typeof AuthedOrgCardsIdRouteImport
      parentRoute: typeof AuthedOrgCardsRoute
    }
    '/_authed/_org/budgets/create': {
      id: '/_authed/_org/budgets/create'
      path: '/create'
      fullPath: '/budgets/create'
      preLoaderRoute: typeof AuthedOrgBudgetsCreateRouteImport
      parentRoute: typeof AuthedOrgBudgetsRoute
    }
    '/_authed/_org/budgets/$groupId': {
      id: '/_authed/_org/budgets/$groupId'
      path: '/$groupId'
      fullPath: '/budgets/$groupId'
      preLoaderRoute: typeof AuthedOrgBudgetsGroupIdRouteImport
      parentRoute: typeof AuthedOrgBudgetsRoute
    }
    '/_authed/_org/accounting/sync-history': {
      id: '/_authed/_org/accounting/sync-history'
      path: '/sync-history'
      fullPath: '/accounting/sync-history'
      preLoaderRoute: typeof AuthedOrgAccountingSyncHistoryRouteImport
      parentRoute: typeof AuthedOrgAccountingRoute
    }
    '/_authed/_org/accounting/settings': {
      id: '/_authed/_org/accounting/settings'
      path: '/settings'
      fullPath: '/accounting/settings'
      preLoaderRoute: typeof AuthedOrgAccountingSettingsRouteImport
      parentRoute: typeof AuthedOrgAccountingRoute
    }
    '/_authed/_onboard/onboard/approved': {
      id: '/_authed/_onboard/onboard/approved'
      path: '/onboard/approved'
      fullPath: '/onboard/approved'
      preLoaderRoute: typeof AuthedOnboardOnboardApprovedRouteImport
      parentRoute: typeof AuthedOnboardRoute
    }
    '/_authed/_org/tax/$id/': {
      id: '/_authed/_org/tax/$id/'
      path: '/$id'
      fullPath: '/tax/$id'
      preLoaderRoute: typeof AuthedOrgTaxIdIndexRouteImport
      parentRoute: typeof AuthedOrgTaxRoute
    }
    '/_authed/_org/settings/change-phone/': {
      id: '/_authed/_org/settings/change-phone/'
      path: '/change-phone'
      fullPath: '/settings/change-phone'
      preLoaderRoute: typeof AuthedOrgSettingsChangePhoneIndexRouteImport
      parentRoute: typeof AuthedOrgSettingsRoute
    }
    '/_authed/_org/settings/change-email/': {
      id: '/_authed/_org/settings/change-email/'
      path: '/change-email'
      fullPath: '/settings/change-email'
      preLoaderRoute: typeof AuthedOrgSettingsChangeEmailIndexRouteImport
      parentRoute: typeof AuthedOrgSettingsRoute
    }
    '/_authed/_org/requests/$id/': {
      id: '/_authed/_org/requests/$id/'
      path: '/'
      fullPath: '/requests/$id/'
      preLoaderRoute: typeof AuthedOrgRequestsIdIndexRouteImport
      parentRoute: typeof AuthedOrgRequestsIdRoute
    }
    '/_authed/_org/organization/settings/': {
      id: '/_authed/_org/organization/settings/'
      path: '/settings'
      fullPath: '/organization/settings'
      preLoaderRoute: typeof AuthedOrgOrganizationSettingsIndexRouteImport
      parentRoute: typeof AuthedOrgOrganizationRoute
    }
    '/_authed/_org/cards/$id/': {
      id: '/_authed/_org/cards/$id/'
      path: '/'
      fullPath: '/cards/$id/'
      preLoaderRoute: typeof AuthedOrgCardsIdIndexRouteImport
      parentRoute: typeof AuthedOrgCardsIdRoute
    }
    '/_authed/_org/budgets/$groupId/': {
      id: '/_authed/_org/budgets/$groupId/'
      path: '/'
      fullPath: '/budgets/$groupId/'
      preLoaderRoute: typeof AuthedOrgBudgetsGroupIdIndexRouteImport
      parentRoute: typeof AuthedOrgBudgetsGroupIdRoute
    }
    '/_authed/_org/accounting/$id/': {
      id: '/_authed/_org/accounting/$id/'
      path: '/$id'
      fullPath: '/accounting/$id'
      preLoaderRoute: typeof AuthedOrgAccountingIdIndexRouteImport
      parentRoute: typeof AuthedOrgAccountingRoute
    }
    '/_authed/_org/transactions/reimbursements/settings': {
      id: '/_authed/_org/transactions/reimbursements/settings'
      path: '/settings'
      fullPath: '/transactions/reimbursements/settings'
      preLoaderRoute: typeof AuthedOrgTransactionsReimbursementsSettingsRouteImport
      parentRoute: typeof AuthedOrgTransactionsReimbursementsRoute
    }
    '/_authed/_org/transactions/reimbursements/create': {
      id: '/_authed/_org/transactions/reimbursements/create'
      path: '/create'
      fullPath: '/transactions/reimbursements/create'
      preLoaderRoute: typeof AuthedOrgTransactionsReimbursementsCreateRouteImport
      parentRoute: typeof AuthedOrgTransactionsReimbursementsRoute
    }
    '/_authed/_org/transactions/reimbursements/$id': {
      id: '/_authed/_org/transactions/reimbursements/$id'
      path: '/$id'
      fullPath: '/transactions/reimbursements/$id'
      preLoaderRoute: typeof AuthedOrgTransactionsReimbursementsIdRouteImport
      parentRoute: typeof AuthedOrgTransactionsReimbursementsRoute
    }
    '/_authed/_org/transactions/card/$id': {
      id: '/_authed/_org/transactions/card/$id'
      path: '/$id'
      fullPath: '/transactions/card/$id'
      preLoaderRoute: typeof AuthedOrgTransactionsCardIdRouteImport
      parentRoute: typeof AuthedOrgTransactionsCardRoute
    }
    '/_authed/_org/settings/change-phone/confirm': {
      id: '/_authed/_org/settings/change-phone/confirm'
      path: '/change-phone/confirm'
      fullPath: '/settings/change-phone/confirm'
      preLoaderRoute: typeof AuthedOrgSettingsChangePhoneConfirmRouteImport
      parentRoute: typeof AuthedOrgSettingsRoute
    }
    '/_authed/_org/settings/change-email/confirm': {
      id: '/_authed/_org/settings/change-email/confirm'
      path: '/change-email/confirm'
      fullPath: '/settings/change-email/confirm'
      preLoaderRoute: typeof AuthedOrgSettingsChangeEmailConfirmRouteImport
      parentRoute: typeof AuthedOrgSettingsRoute
    }
    '/_authed/_org/requests/create/limit-increase': {
      id: '/_authed/_org/requests/create/limit-increase'
      path: '/create/limit-increase'
      fullPath: '/requests/create/limit-increase'
      preLoaderRoute: typeof AuthedOrgRequestsCreateLimitIncreaseRouteImport
      parentRoute: typeof AuthedOrgRequestsRoute
    }
    '/_authed/_org/requests/create/card': {
      id: '/_authed/_org/requests/create/card'
      path: '/create/card'
      fullPath: '/requests/create/card'
      preLoaderRoute: typeof AuthedOrgRequestsCreateCardRouteImport
      parentRoute: typeof AuthedOrgRequestsRoute
    }
    '/_authed/_org/requests/$id/edit': {
      id: '/_authed/_org/requests/$id/edit'
      path: '/edit'
      fullPath: '/requests/$id/edit'
      preLoaderRoute: typeof AuthedOrgRequestsIdEditRouteImport
      parentRoute: typeof AuthedOrgRequestsIdRoute
    }
    '/_authed/_org/policies/expense/create': {
      id: '/_authed/_org/policies/expense/create'
      path: '/create'
      fullPath: '/policies/expense/create'
      preLoaderRoute: typeof AuthedOrgPoliciesExpenseCreateRouteImport
      parentRoute: typeof AuthedOrgPoliciesExpenseRoute
    }
    '/_authed/_org/policies/approval/create': {
      id: '/_authed/_org/policies/approval/create'
      path: '/create'
      fullPath: '/policies/approval/create'
      preLoaderRoute: typeof AuthedOrgPoliciesApprovalCreateRouteImport
      parentRoute: typeof AuthedOrgPoliciesApprovalRoute
    }
    '/_authed/_org/organization/people/invitations': {
      id: '/_authed/_org/organization/people/invitations'
      path: '/invitations'
      fullPath: '/organization/people/invitations'
      preLoaderRoute: typeof AuthedOrgOrganizationPeopleInvitationsRouteImport
      parentRoute: typeof AuthedOrgOrganizationPeopleRoute
    }
    '/_authed/_org/organization/people/all': {
      id: '/_authed/_org/organization/people/all'
      path: '/all'
      fullPath: '/organization/people/all'
      preLoaderRoute: typeof AuthedOrgOrganizationPeopleAllRouteImport
      parentRoute: typeof AuthedOrgOrganizationPeopleRoute
    }
    '/_authed/_org/cards/$id/transactions': {
      id: '/_authed/_org/cards/$id/transactions'
      path: '/transactions'
      fullPath: '/cards/$id/transactions'
      preLoaderRoute: typeof AuthedOrgCardsIdTransactionsRouteImport
      parentRoute: typeof AuthedOrgCardsIdRoute
    }
    '/_authed/_org/cards/$id/edit': {
      id: '/_authed/_org/cards/$id/edit'
      path: '/edit'
      fullPath: '/cards/$id/edit'
      preLoaderRoute: typeof AuthedOrgCardsIdEditRouteImport
      parentRoute: typeof AuthedOrgCardsIdRoute
    }
    '/_authed/_org/cards/$id/activity': {
      id: '/_authed/_org/cards/$id/activity'
      path: '/activity'
      fullPath: '/cards/$id/activity'
      preLoaderRoute: typeof AuthedOrgCardsIdActivityRouteImport
      parentRoute: typeof AuthedOrgCardsIdRoute
    }
    '/_authed/_org/budgets/$groupId/reporting': {
      id: '/_authed/_org/budgets/$groupId/reporting'
      path: '/reporting'
      fullPath: '/budgets/$groupId/reporting'
      preLoaderRoute: typeof AuthedOrgBudgetsGroupIdReportingRouteImport
      parentRoute: typeof AuthedOrgBudgetsGroupIdRoute
    }
    '/_authed/_org/budgets/$groupId/edit': {
      id: '/_authed/_org/budgets/$groupId/edit'
      path: '/edit'
      fullPath: '/budgets/$groupId/edit'
      preLoaderRoute: typeof AuthedOrgBudgetsGroupIdEditRouteImport
      parentRoute: typeof AuthedOrgBudgetsGroupIdRoute
    }
    '/_authed/_org/accounting/sync-history/$id': {
      id: '/_authed/_org/accounting/sync-history/$id'
      path: '/$id'
      fullPath: '/accounting/sync-history/$id'
      preLoaderRoute: typeof AuthedOrgAccountingSyncHistoryIdRouteImport
      parentRoute: typeof AuthedOrgAccountingSyncHistoryRoute
    }
    '/_authed/_org/accounting/settings/rules': {
      id: '/_authed/_org/accounting/settings/rules'
      path: '/rules'
      fullPath: '/accounting/settings/rules'
      preLoaderRoute: typeof AuthedOrgAccountingSettingsRulesRouteImport
      parentRoute: typeof AuthedOrgAccountingSettingsRoute
    }
    '/_authed/_org/accounting/settings/fields': {
      id: '/_authed/_org/accounting/settings/fields'
      path: '/fields'
      fullPath: '/accounting/settings/fields'
      preLoaderRoute: typeof AuthedOrgAccountingSettingsFieldsRouteImport
      parentRoute: typeof AuthedOrgAccountingSettingsRoute
    }
    '/_authed/_org/policies/expense/$id/edit': {
      id: '/_authed/_org/policies/expense/$id/edit'
      path: '/$id/edit'
      fullPath: '/policies/expense/$id/edit'
      preLoaderRoute: typeof AuthedOrgPoliciesExpenseIdEditRouteImport
      parentRoute: typeof AuthedOrgPoliciesExpenseRoute
    }
    '/_authed/_org/policies/approval/$id/edit': {
      id: '/_authed/_org/policies/approval/$id/edit'
      path: '/$id/edit'
      fullPath: '/policies/approval/$id/edit'
      preLoaderRoute: typeof AuthedOrgPoliciesApprovalIdEditRouteImport
      parentRoute: typeof AuthedOrgPoliciesApprovalRoute
    }
    '/_authed/_org/accounting/settings/fields/$id': {
      id: '/_authed/_org/accounting/settings/fields/$id'
      path: '/$id'
      fullPath: '/accounting/settings/fields/$id'
      preLoaderRoute: typeof AuthedOrgAccountingSettingsFieldsIdRouteImport
      parentRoute: typeof AuthedOrgAccountingSettingsFieldsRoute
    }
    '/_authed/_org/organization/people/all/$id/': {
      id: '/_authed/_org/organization/people/all/$id/'
      path: '/$id'
      fullPath: '/organization/people/all/$id'
      preLoaderRoute: typeof AuthedOrgOrganizationPeopleAllIdIndexRouteImport
      parentRoute: typeof AuthedOrgOrganizationPeopleAllRoute
    }
    '/_authed/_org/organization/people/all/$id/edit-role': {
      id: '/_authed/_org/organization/people/all/$id/edit-role'
      path: '/$id/edit-role'
      fullPath: '/organization/people/all/$id/edit-role'
      preLoaderRoute: typeof AuthedOrgOrganizationPeopleAllIdEditRoleRouteImport
      parentRoute: typeof AuthedOrgOrganizationPeopleAllRoute
    }
  }
}

interface AuthedOnboardRouteChildren {
  AuthedOnboardOnboardApprovedRoute: typeof AuthedOnboardOnboardApprovedRoute
  AuthedOnboardOnboardIndexRoute: typeof AuthedOnboardOnboardIndexRoute
}

const AuthedOnboardRouteChildren: AuthedOnboardRouteChildren = {
  AuthedOnboardOnboardApprovedRoute: AuthedOnboardOnboardApprovedRoute,
  AuthedOnboardOnboardIndexRoute: AuthedOnboardOnboardIndexRoute,
}

const AuthedOnboardRouteWithChildren = AuthedOnboardRoute._addFileChildren(
  AuthedOnboardRouteChildren,
)

interface AuthedOrgAccountingSettingsFieldsRouteChildren {
  AuthedOrgAccountingSettingsFieldsIdRoute: typeof AuthedOrgAccountingSettingsFieldsIdRoute
}

const AuthedOrgAccountingSettingsFieldsRouteChildren: AuthedOrgAccountingSettingsFieldsRouteChildren =
  {
    AuthedOrgAccountingSettingsFieldsIdRoute:
      AuthedOrgAccountingSettingsFieldsIdRoute,
  }

const AuthedOrgAccountingSettingsFieldsRouteWithChildren =
  AuthedOrgAccountingSettingsFieldsRoute._addFileChildren(
    AuthedOrgAccountingSettingsFieldsRouteChildren,
  )

interface AuthedOrgAccountingSettingsRouteChildren {
  AuthedOrgAccountingSettingsFieldsRoute: typeof AuthedOrgAccountingSettingsFieldsRouteWithChildren
  AuthedOrgAccountingSettingsRulesRoute: typeof AuthedOrgAccountingSettingsRulesRoute
}

const AuthedOrgAccountingSettingsRouteChildren: AuthedOrgAccountingSettingsRouteChildren =
  {
    AuthedOrgAccountingSettingsFieldsRoute:
      AuthedOrgAccountingSettingsFieldsRouteWithChildren,
    AuthedOrgAccountingSettingsRulesRoute:
      AuthedOrgAccountingSettingsRulesRoute,
  }

const AuthedOrgAccountingSettingsRouteWithChildren =
  AuthedOrgAccountingSettingsRoute._addFileChildren(
    AuthedOrgAccountingSettingsRouteChildren,
  )

interface AuthedOrgAccountingSyncHistoryRouteChildren {
  AuthedOrgAccountingSyncHistoryIdRoute: typeof AuthedOrgAccountingSyncHistoryIdRoute
}

const AuthedOrgAccountingSyncHistoryRouteChildren: AuthedOrgAccountingSyncHistoryRouteChildren =
  {
    AuthedOrgAccountingSyncHistoryIdRoute:
      AuthedOrgAccountingSyncHistoryIdRoute,
  }

const AuthedOrgAccountingSyncHistoryRouteWithChildren =
  AuthedOrgAccountingSyncHistoryRoute._addFileChildren(
    AuthedOrgAccountingSyncHistoryRouteChildren,
  )

interface AuthedOrgAccountingRouteChildren {
  AuthedOrgAccountingSettingsRoute: typeof AuthedOrgAccountingSettingsRouteWithChildren
  AuthedOrgAccountingSyncHistoryRoute: typeof AuthedOrgAccountingSyncHistoryRouteWithChildren
  AuthedOrgAccountingIdIndexRoute: typeof AuthedOrgAccountingIdIndexRoute
}

const AuthedOrgAccountingRouteChildren: AuthedOrgAccountingRouteChildren = {
  AuthedOrgAccountingSettingsRoute:
    AuthedOrgAccountingSettingsRouteWithChildren,
  AuthedOrgAccountingSyncHistoryRoute:
    AuthedOrgAccountingSyncHistoryRouteWithChildren,
  AuthedOrgAccountingIdIndexRoute: AuthedOrgAccountingIdIndexRoute,
}

const AuthedOrgAccountingRouteWithChildren =
  AuthedOrgAccountingRoute._addFileChildren(AuthedOrgAccountingRouteChildren)

interface AuthedOrgBudgetsGroupIdRouteChildren {
  AuthedOrgBudgetsGroupIdEditRoute: typeof AuthedOrgBudgetsGroupIdEditRoute
  AuthedOrgBudgetsGroupIdReportingRoute: typeof AuthedOrgBudgetsGroupIdReportingRoute
  AuthedOrgBudgetsGroupIdIndexRoute: typeof AuthedOrgBudgetsGroupIdIndexRoute
}

const AuthedOrgBudgetsGroupIdRouteChildren: AuthedOrgBudgetsGroupIdRouteChildren =
  {
    AuthedOrgBudgetsGroupIdEditRoute: AuthedOrgBudgetsGroupIdEditRoute,
    AuthedOrgBudgetsGroupIdReportingRoute:
      AuthedOrgBudgetsGroupIdReportingRoute,
    AuthedOrgBudgetsGroupIdIndexRoute: AuthedOrgBudgetsGroupIdIndexRoute,
  }

const AuthedOrgBudgetsGroupIdRouteWithChildren =
  AuthedOrgBudgetsGroupIdRoute._addFileChildren(
    AuthedOrgBudgetsGroupIdRouteChildren,
  )

interface AuthedOrgBudgetsRouteChildren {
  AuthedOrgBudgetsGroupIdRoute: typeof AuthedOrgBudgetsGroupIdRouteWithChildren
  AuthedOrgBudgetsCreateRoute: typeof AuthedOrgBudgetsCreateRoute
}

const AuthedOrgBudgetsRouteChildren: AuthedOrgBudgetsRouteChildren = {
  AuthedOrgBudgetsGroupIdRoute: AuthedOrgBudgetsGroupIdRouteWithChildren,
  AuthedOrgBudgetsCreateRoute: AuthedOrgBudgetsCreateRoute,
}

const AuthedOrgBudgetsRouteWithChildren =
  AuthedOrgBudgetsRoute._addFileChildren(AuthedOrgBudgetsRouteChildren)

interface AuthedOrgCardsIdRouteChildren {
  AuthedOrgCardsIdActivityRoute: typeof AuthedOrgCardsIdActivityRoute
  AuthedOrgCardsIdEditRoute: typeof AuthedOrgCardsIdEditRoute
  AuthedOrgCardsIdTransactionsRoute: typeof AuthedOrgCardsIdTransactionsRoute
  AuthedOrgCardsIdIndexRoute: typeof AuthedOrgCardsIdIndexRoute
}

const AuthedOrgCardsIdRouteChildren: AuthedOrgCardsIdRouteChildren = {
  AuthedOrgCardsIdActivityRoute: AuthedOrgCardsIdActivityRoute,
  AuthedOrgCardsIdEditRoute: AuthedOrgCardsIdEditRoute,
  AuthedOrgCardsIdTransactionsRoute: AuthedOrgCardsIdTransactionsRoute,
  AuthedOrgCardsIdIndexRoute: AuthedOrgCardsIdIndexRoute,
}

const AuthedOrgCardsIdRouteWithChildren =
  AuthedOrgCardsIdRoute._addFileChildren(AuthedOrgCardsIdRouteChildren)

interface AuthedOrgCardsRouteChildren {
  AuthedOrgCardsIdRoute: typeof AuthedOrgCardsIdRouteWithChildren
  AuthedOrgCardsCreateRoute: typeof AuthedOrgCardsCreateRoute
}

const AuthedOrgCardsRouteChildren: AuthedOrgCardsRouteChildren = {
  AuthedOrgCardsIdRoute: AuthedOrgCardsIdRouteWithChildren,
  AuthedOrgCardsCreateRoute: AuthedOrgCardsCreateRoute,
}

const AuthedOrgCardsRouteWithChildren = AuthedOrgCardsRoute._addFileChildren(
  AuthedOrgCardsRouteChildren,
)

interface AuthedOrgOrganizationPeopleAllRouteChildren {
  AuthedOrgOrganizationPeopleAllIdEditRoleRoute: typeof AuthedOrgOrganizationPeopleAllIdEditRoleRoute
  AuthedOrgOrganizationPeopleAllIdIndexRoute: typeof AuthedOrgOrganizationPeopleAllIdIndexRoute
}

const AuthedOrgOrganizationPeopleAllRouteChildren: AuthedOrgOrganizationPeopleAllRouteChildren =
  {
    AuthedOrgOrganizationPeopleAllIdEditRoleRoute:
      AuthedOrgOrganizationPeopleAllIdEditRoleRoute,
    AuthedOrgOrganizationPeopleAllIdIndexRoute:
      AuthedOrgOrganizationPeopleAllIdIndexRoute,
  }

const AuthedOrgOrganizationPeopleAllRouteWithChildren =
  AuthedOrgOrganizationPeopleAllRoute._addFileChildren(
    AuthedOrgOrganizationPeopleAllRouteChildren,
  )

interface AuthedOrgOrganizationPeopleRouteChildren {
  AuthedOrgOrganizationPeopleAllRoute: typeof AuthedOrgOrganizationPeopleAllRouteWithChildren
  AuthedOrgOrganizationPeopleInvitationsRoute: typeof AuthedOrgOrganizationPeopleInvitationsRoute
}

const AuthedOrgOrganizationPeopleRouteChildren: AuthedOrgOrganizationPeopleRouteChildren =
  {
    AuthedOrgOrganizationPeopleAllRoute:
      AuthedOrgOrganizationPeopleAllRouteWithChildren,
    AuthedOrgOrganizationPeopleInvitationsRoute:
      AuthedOrgOrganizationPeopleInvitationsRoute,
  }

const AuthedOrgOrganizationPeopleRouteWithChildren =
  AuthedOrgOrganizationPeopleRoute._addFileChildren(
    AuthedOrgOrganizationPeopleRouteChildren,
  )

interface AuthedOrgOrganizationRouteChildren {
  AuthedOrgOrganizationPeopleRoute: typeof AuthedOrgOrganizationPeopleRouteWithChildren
  AuthedOrgOrganizationStatementsRoute: typeof AuthedOrgOrganizationStatementsRoute
  AuthedOrgOrganizationIndexRoute: typeof AuthedOrgOrganizationIndexRoute
  AuthedOrgOrganizationSettingsIndexRoute: typeof AuthedOrgOrganizationSettingsIndexRoute
}

const AuthedOrgOrganizationRouteChildren: AuthedOrgOrganizationRouteChildren = {
  AuthedOrgOrganizationPeopleRoute:
    AuthedOrgOrganizationPeopleRouteWithChildren,
  AuthedOrgOrganizationStatementsRoute: AuthedOrgOrganizationStatementsRoute,
  AuthedOrgOrganizationIndexRoute: AuthedOrgOrganizationIndexRoute,
  AuthedOrgOrganizationSettingsIndexRoute:
    AuthedOrgOrganizationSettingsIndexRoute,
}

const AuthedOrgOrganizationRouteWithChildren =
  AuthedOrgOrganizationRoute._addFileChildren(
    AuthedOrgOrganizationRouteChildren,
  )

interface AuthedOrgPoliciesApprovalRouteChildren {
  AuthedOrgPoliciesApprovalCreateRoute: typeof AuthedOrgPoliciesApprovalCreateRoute
  AuthedOrgPoliciesApprovalIdEditRoute: typeof AuthedOrgPoliciesApprovalIdEditRoute
}

const AuthedOrgPoliciesApprovalRouteChildren: AuthedOrgPoliciesApprovalRouteChildren =
  {
    AuthedOrgPoliciesApprovalCreateRoute: AuthedOrgPoliciesApprovalCreateRoute,
    AuthedOrgPoliciesApprovalIdEditRoute: AuthedOrgPoliciesApprovalIdEditRoute,
  }

const AuthedOrgPoliciesApprovalRouteWithChildren =
  AuthedOrgPoliciesApprovalRoute._addFileChildren(
    AuthedOrgPoliciesApprovalRouteChildren,
  )

interface AuthedOrgPoliciesExpenseRouteChildren {
  AuthedOrgPoliciesExpenseCreateRoute: typeof AuthedOrgPoliciesExpenseCreateRoute
  AuthedOrgPoliciesExpenseIdEditRoute: typeof AuthedOrgPoliciesExpenseIdEditRoute
}

const AuthedOrgPoliciesExpenseRouteChildren: AuthedOrgPoliciesExpenseRouteChildren =
  {
    AuthedOrgPoliciesExpenseCreateRoute: AuthedOrgPoliciesExpenseCreateRoute,
    AuthedOrgPoliciesExpenseIdEditRoute: AuthedOrgPoliciesExpenseIdEditRoute,
  }

const AuthedOrgPoliciesExpenseRouteWithChildren =
  AuthedOrgPoliciesExpenseRoute._addFileChildren(
    AuthedOrgPoliciesExpenseRouteChildren,
  )

interface AuthedOrgPoliciesRouteChildren {
  AuthedOrgPoliciesApprovalRoute: typeof AuthedOrgPoliciesApprovalRouteWithChildren
  AuthedOrgPoliciesExpenseRoute: typeof AuthedOrgPoliciesExpenseRouteWithChildren
}

const AuthedOrgPoliciesRouteChildren: AuthedOrgPoliciesRouteChildren = {
  AuthedOrgPoliciesApprovalRoute: AuthedOrgPoliciesApprovalRouteWithChildren,
  AuthedOrgPoliciesExpenseRoute: AuthedOrgPoliciesExpenseRouteWithChildren,
}

const AuthedOrgPoliciesRouteWithChildren =
  AuthedOrgPoliciesRoute._addFileChildren(AuthedOrgPoliciesRouteChildren)

interface AuthedOrgReferralsRouteChildren {
  AuthedOrgReferralsHowItWorksRoute: typeof AuthedOrgReferralsHowItWorksRoute
  AuthedOrgReferralsSendRoute: typeof AuthedOrgReferralsSendRoute
}

const AuthedOrgReferralsRouteChildren: AuthedOrgReferralsRouteChildren = {
  AuthedOrgReferralsHowItWorksRoute: AuthedOrgReferralsHowItWorksRoute,
  AuthedOrgReferralsSendRoute: AuthedOrgReferralsSendRoute,
}

const AuthedOrgReferralsRouteWithChildren =
  AuthedOrgReferralsRoute._addFileChildren(AuthedOrgReferralsRouteChildren)

interface AuthedOrgRequestsIdRouteChildren {
  AuthedOrgRequestsIdEditRoute: typeof AuthedOrgRequestsIdEditRoute
  AuthedOrgRequestsIdIndexRoute: typeof AuthedOrgRequestsIdIndexRoute
}

const AuthedOrgRequestsIdRouteChildren: AuthedOrgRequestsIdRouteChildren = {
  AuthedOrgRequestsIdEditRoute: AuthedOrgRequestsIdEditRoute,
  AuthedOrgRequestsIdIndexRoute: AuthedOrgRequestsIdIndexRoute,
}

const AuthedOrgRequestsIdRouteWithChildren =
  AuthedOrgRequestsIdRoute._addFileChildren(AuthedOrgRequestsIdRouteChildren)

interface AuthedOrgRequestsRouteChildren {
  AuthedOrgRequestsIdRoute: typeof AuthedOrgRequestsIdRouteWithChildren
  AuthedOrgRequestsCreateCardRoute: typeof AuthedOrgRequestsCreateCardRoute
  AuthedOrgRequestsCreateLimitIncreaseRoute: typeof AuthedOrgRequestsCreateLimitIncreaseRoute
}

const AuthedOrgRequestsRouteChildren: AuthedOrgRequestsRouteChildren = {
  AuthedOrgRequestsIdRoute: AuthedOrgRequestsIdRouteWithChildren,
  AuthedOrgRequestsCreateCardRoute: AuthedOrgRequestsCreateCardRoute,
  AuthedOrgRequestsCreateLimitIncreaseRoute:
    AuthedOrgRequestsCreateLimitIncreaseRoute,
}

const AuthedOrgRequestsRouteWithChildren =
  AuthedOrgRequestsRoute._addFileChildren(AuthedOrgRequestsRouteChildren)

interface AuthedOrgSettingsRouteChildren {
  AuthedOrgSettingsBankRoute: typeof AuthedOrgSettingsBankRoute
  AuthedOrgSettingsDevelopmentRoute: typeof AuthedOrgSettingsDevelopmentRoute
  AuthedOrgSettingsNotificationsRoute: typeof AuthedOrgSettingsNotificationsRoute
  AuthedOrgSettingsProfileRoute: typeof AuthedOrgSettingsProfileRoute
  AuthedOrgSettingsIndexRoute: typeof AuthedOrgSettingsIndexRoute
  AuthedOrgSettingsChangeEmailConfirmRoute: typeof AuthedOrgSettingsChangeEmailConfirmRoute
  AuthedOrgSettingsChangePhoneConfirmRoute: typeof AuthedOrgSettingsChangePhoneConfirmRoute
  AuthedOrgSettingsChangeEmailIndexRoute: typeof AuthedOrgSettingsChangeEmailIndexRoute
  AuthedOrgSettingsChangePhoneIndexRoute: typeof AuthedOrgSettingsChangePhoneIndexRoute
}

const AuthedOrgSettingsRouteChildren: AuthedOrgSettingsRouteChildren = {
  AuthedOrgSettingsBankRoute: AuthedOrgSettingsBankRoute,
  AuthedOrgSettingsDevelopmentRoute: AuthedOrgSettingsDevelopmentRoute,
  AuthedOrgSettingsNotificationsRoute: AuthedOrgSettingsNotificationsRoute,
  AuthedOrgSettingsProfileRoute: AuthedOrgSettingsProfileRoute,
  AuthedOrgSettingsIndexRoute: AuthedOrgSettingsIndexRoute,
  AuthedOrgSettingsChangeEmailConfirmRoute:
    AuthedOrgSettingsChangeEmailConfirmRoute,
  AuthedOrgSettingsChangePhoneConfirmRoute:
    AuthedOrgSettingsChangePhoneConfirmRoute,
  AuthedOrgSettingsChangeEmailIndexRoute:
    AuthedOrgSettingsChangeEmailIndexRoute,
  AuthedOrgSettingsChangePhoneIndexRoute:
    AuthedOrgSettingsChangePhoneIndexRoute,
}

const AuthedOrgSettingsRouteWithChildren =
  AuthedOrgSettingsRoute._addFileChildren(AuthedOrgSettingsRouteChildren)

interface AuthedOrgTaxRouteChildren {
  AuthedOrgTaxRefundsRoute: typeof AuthedOrgTaxRefundsRoute
  AuthedOrgTaxIdIndexRoute: typeof AuthedOrgTaxIdIndexRoute
}

const AuthedOrgTaxRouteChildren: AuthedOrgTaxRouteChildren = {
  AuthedOrgTaxRefundsRoute: AuthedOrgTaxRefundsRoute,
  AuthedOrgTaxIdIndexRoute: AuthedOrgTaxIdIndexRoute,
}

const AuthedOrgTaxRouteWithChildren = AuthedOrgTaxRoute._addFileChildren(
  AuthedOrgTaxRouteChildren,
)

interface AuthedOrgTransactionsCardRouteChildren {
  AuthedOrgTransactionsCardIdRoute: typeof AuthedOrgTransactionsCardIdRoute
}

const AuthedOrgTransactionsCardRouteChildren: AuthedOrgTransactionsCardRouteChildren =
  {
    AuthedOrgTransactionsCardIdRoute: AuthedOrgTransactionsCardIdRoute,
  }

const AuthedOrgTransactionsCardRouteWithChildren =
  AuthedOrgTransactionsCardRoute._addFileChildren(
    AuthedOrgTransactionsCardRouteChildren,
  )

interface AuthedOrgTransactionsReimbursementsRouteChildren {
  AuthedOrgTransactionsReimbursementsIdRoute: typeof AuthedOrgTransactionsReimbursementsIdRoute
  AuthedOrgTransactionsReimbursementsCreateRoute: typeof AuthedOrgTransactionsReimbursementsCreateRoute
  AuthedOrgTransactionsReimbursementsSettingsRoute: typeof AuthedOrgTransactionsReimbursementsSettingsRoute
}

const AuthedOrgTransactionsReimbursementsRouteChildren: AuthedOrgTransactionsReimbursementsRouteChildren =
  {
    AuthedOrgTransactionsReimbursementsIdRoute:
      AuthedOrgTransactionsReimbursementsIdRoute,
    AuthedOrgTransactionsReimbursementsCreateRoute:
      AuthedOrgTransactionsReimbursementsCreateRoute,
    AuthedOrgTransactionsReimbursementsSettingsRoute:
      AuthedOrgTransactionsReimbursementsSettingsRoute,
  }

const AuthedOrgTransactionsReimbursementsRouteWithChildren =
  AuthedOrgTransactionsReimbursementsRoute._addFileChildren(
    AuthedOrgTransactionsReimbursementsRouteChildren,
  )

interface AuthedOrgTransactionsRouteChildren {
  AuthedOrgTransactionsIdRoute: typeof AuthedOrgTransactionsIdRoute
  AuthedOrgTransactionsCardRoute: typeof AuthedOrgTransactionsCardRouteWithChildren
  AuthedOrgTransactionsReimbursementsRoute: typeof AuthedOrgTransactionsReimbursementsRouteWithChildren
}

const AuthedOrgTransactionsRouteChildren: AuthedOrgTransactionsRouteChildren = {
  AuthedOrgTransactionsIdRoute: AuthedOrgTransactionsIdRoute,
  AuthedOrgTransactionsCardRoute: AuthedOrgTransactionsCardRouteWithChildren,
  AuthedOrgTransactionsReimbursementsRoute:
    AuthedOrgTransactionsReimbursementsRouteWithChildren,
}

const AuthedOrgTransactionsRouteWithChildren =
  AuthedOrgTransactionsRoute._addFileChildren(
    AuthedOrgTransactionsRouteChildren,
  )

interface AuthedOrgRouteChildren {
  AuthedOrgAccountingRoute: typeof AuthedOrgAccountingRouteWithChildren
  AuthedOrgBillPayRoute: typeof AuthedOrgBillPayRoute
  AuthedOrgBudgetsRoute: typeof AuthedOrgBudgetsRouteWithChildren
  AuthedOrgCardsRoute: typeof AuthedOrgCardsRouteWithChildren
  AuthedOrgDashboardRoute: typeof AuthedOrgDashboardRoute
  AuthedOrgInsightsRoute: typeof AuthedOrgInsightsRoute
  AuthedOrgOrganizationRoute: typeof AuthedOrgOrganizationRouteWithChildren
  AuthedOrgPoliciesRoute: typeof AuthedOrgPoliciesRouteWithChildren
  AuthedOrgReferralsRoute: typeof AuthedOrgReferralsRouteWithChildren
  AuthedOrgRequestsRoute: typeof AuthedOrgRequestsRouteWithChildren
  AuthedOrgSettingsRoute: typeof AuthedOrgSettingsRouteWithChildren
  AuthedOrgTaxRoute: typeof AuthedOrgTaxRouteWithChildren
  AuthedOrgTaxSetupRoute: typeof AuthedOrgTaxSetupRoute
  AuthedOrgTestRoute: typeof AuthedOrgTestRoute
  AuthedOrgTransactionsRoute: typeof AuthedOrgTransactionsRouteWithChildren
  AuthedOrgAccountingSetupIndexRoute: typeof AuthedOrgAccountingSetupIndexRoute
}

const AuthedOrgRouteChildren: AuthedOrgRouteChildren = {
  AuthedOrgAccountingRoute: AuthedOrgAccountingRouteWithChildren,
  AuthedOrgBillPayRoute: AuthedOrgBillPayRoute,
  AuthedOrgBudgetsRoute: AuthedOrgBudgetsRouteWithChildren,
  AuthedOrgCardsRoute: AuthedOrgCardsRouteWithChildren,
  AuthedOrgDashboardRoute: AuthedOrgDashboardRoute,
  AuthedOrgInsightsRoute: AuthedOrgInsightsRoute,
  AuthedOrgOrganizationRoute: AuthedOrgOrganizationRouteWithChildren,
  AuthedOrgPoliciesRoute: AuthedOrgPoliciesRouteWithChildren,
  AuthedOrgReferralsRoute: AuthedOrgReferralsRouteWithChildren,
  AuthedOrgRequestsRoute: AuthedOrgRequestsRouteWithChildren,
  AuthedOrgSettingsRoute: AuthedOrgSettingsRouteWithChildren,
  AuthedOrgTaxRoute: AuthedOrgTaxRouteWithChildren,
  AuthedOrgTaxSetupRoute: AuthedOrgTaxSetupRoute,
  AuthedOrgTestRoute: AuthedOrgTestRoute,
  AuthedOrgTransactionsRoute: AuthedOrgTransactionsRouteWithChildren,
  AuthedOrgAccountingSetupIndexRoute: AuthedOrgAccountingSetupIndexRoute,
}

const AuthedOrgRouteWithChildren = AuthedOrgRoute._addFileChildren(
  AuthedOrgRouteChildren,
)

interface AuthedRouteChildren {
  AuthedOnboardRoute: typeof AuthedOnboardRouteWithChildren
  AuthedOrgRoute: typeof AuthedOrgRouteWithChildren
  AuthedCreateOrganizationRoute: typeof AuthedCreateOrganizationRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedOnboardRoute: AuthedOnboardRouteWithChildren,
  AuthedOrgRoute: AuthedOrgRouteWithChildren,
  AuthedCreateOrganizationRoute: AuthedCreateOrganizationRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

interface UnauthedLoginRouteChildren {
  UnauthedLogin2faRoute: typeof UnauthedLogin2faRoute
  UnauthedLoginIndexRoute: typeof UnauthedLoginIndexRoute
}

const UnauthedLoginRouteChildren: UnauthedLoginRouteChildren = {
  UnauthedLogin2faRoute: UnauthedLogin2faRoute,
  UnauthedLoginIndexRoute: UnauthedLoginIndexRoute,
}

const UnauthedLoginRouteWithChildren = UnauthedLoginRoute._addFileChildren(
  UnauthedLoginRouteChildren,
)

interface UnauthedRouteChildren {
  UnauthedEmailVerifiedRoute: typeof UnauthedEmailVerifiedRoute
  UnauthedForgotPasswordRoute: typeof UnauthedForgotPasswordRoute
  UnauthedLoginRoute: typeof UnauthedLoginRouteWithChildren
  UnauthedResetPasswordRoute: typeof UnauthedResetPasswordRoute
  UnauthedSignUpRoute: typeof UnauthedSignUpRoute
  UnauthedVerifyEmailRoute: typeof UnauthedVerifyEmailRoute
}

const UnauthedRouteChildren: UnauthedRouteChildren = {
  UnauthedEmailVerifiedRoute: UnauthedEmailVerifiedRoute,
  UnauthedForgotPasswordRoute: UnauthedForgotPasswordRoute,
  UnauthedLoginRoute: UnauthedLoginRouteWithChildren,
  UnauthedResetPasswordRoute: UnauthedResetPasswordRoute,
  UnauthedSignUpRoute: UnauthedSignUpRoute,
  UnauthedVerifyEmailRoute: UnauthedVerifyEmailRoute,
}

const UnauthedRouteWithChildren = UnauthedRoute._addFileChildren(
  UnauthedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  UnauthedRoute: UnauthedRouteWithChildren,
  JoinIdRoute: JoinIdRoute,
  TransparencyOrgIdRoute: TransparencyOrgIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
